import { useContext, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import config from 'config'
import ClientContext from 'contexts/ClientContext'
import './OwenAssistant.scss'

// ─── SVG réutilisables ───────────────────────────────────────────────────────

// Wordmark blanc par défaut ; les paths non-orange utilisent currentColor pour
// pouvoir suivre --cb-ovbar-fg (texte foncé) en co-branding fond clair.
const OwenWordmarkWhite = () => (
  <svg viewBox="0 0 72 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.0955 9.36714C19.5022 5.00515 15.4789 1.8012 10.8458 1.20432C10.605 1.16813 10.369 1.36162 10.3522 1.60337L10.1341 4.05361C10.1133 4.2886 10.2812 4.49802 10.5172 4.52986C13.9079 4.99164 16.76 7.28844 17.9605 10.5237C18.0455 10.7549 18.3056 10.8707 18.5285 10.7867L20.8335 9.93073C21.0607 9.84629 21.1785 9.59345 21.0955 9.36714Z" fill="#FFA92C"/>
    <path d="M39.5193 6.67878L34.3342 22.0586C34.2738 22.2381 34.1054 22.3588 33.9163 22.3588H32.1141C31.9389 22.3588 31.7802 22.255 31.7097 22.0943L27.9152 13.4133L24.3523 22.0852C24.2842 22.2512 24.1236 22.3588 23.9441 22.3588H22.1756C21.9865 22.3588 21.8186 22.2386 21.7578 22.0601L18.537 12.6143C18.4467 12.3687 18.6161 12.0801 18.8738 12.0381L21.2593 11.5933C21.4765 11.5527 21.6917 11.6806 21.7597 11.8905L23.3245 16.6945L26.8686 8.86701C26.94 8.70971 27.0978 8.6079 27.2706 8.6079H28.8214C28.9941 8.6079 29.1514 8.70923 29.2228 8.86653L32.7279 16.5777L36.0683 6.40037C36.1282 6.21846 36.2966 6.09686 36.4876 6.09686H39.1005C39.4117 6.09686 39.6105 6.38155 39.5188 6.67926Z" fill="currentColor"/>
    <path d="M44.3976 6.36779C38.2517 8.74566 37.6307 18.5848 43.5599 21.5938C46.8806 23.4645 51.5094 22.7523 54.2294 20.3108C54.3886 20.1621 54.4127 19.9146 54.2844 19.7351L52.9966 17.9271C52.8566 17.7215 52.5439 17.6796 52.3562 17.8431C49.3101 20.7281 43.5382 19.655 42.9543 15.1579H55.0767C55.8704 8.81949 50.5405 3.87171 44.3976 6.36779ZM43.0947 12.299C43.9141 7.97218 51.0486 7.77579 51.5557 12.299H43.0947Z" fill="currentColor"/>
    <path d="M70.5112 8.75003C68.9507 4.65487 62.8381 5.12581 60.482 8.16039V6.53719C60.482 6.294 60.2841 6.09616 60.041 6.09616H57.4291C57.1859 6.09616 56.988 6.294 56.988 6.53719V21.9171C56.988 22.1603 57.1859 22.3581 57.4291 22.3581H60.041C60.2841 22.3581 60.482 22.1603 60.482 21.9171V12.4201C60.4313 10.3723 62.2041 8.96475 64.2162 8.9855C66.3905 8.9855 67.6373 10.339 67.6373 12.6995V21.9185C67.6373 22.1612 67.8351 22.3586 68.0778 22.3586C69.7271 22.3586 71.0921 21.0167 71.1201 19.3674C71.1829 15.7755 71.3484 10.4278 70.5112 8.75051Z" fill="currentColor"/>
    <path d="M9.10542 5.7749C4.5181 5.7749 0.799316 9.09802 0.799316 14.2195C0.799316 19.341 4.369 22.6636 9.10542 22.6636C13.8418 22.6636 17.4115 19.0524 17.4115 14.2195C17.4115 9.38657 14.1497 5.7749 9.10542 5.7749ZM9.10542 19.4433C6.40958 19.4433 4.37817 17.3274 4.37817 14.2195C4.37817 11.1116 6.4945 8.99573 9.10542 8.99573C11.9759 8.99573 13.8327 11.3345 13.8327 14.2195C13.8327 17.1045 11.8674 19.4433 9.10542 19.4433Z" fill="currentColor"/>
  </svg>
)

const OwenOLogoWhiteOrange = () => (
  <svg viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.10542 5.7749C4.5181 5.7749 0.799316 9.09802 0.799316 14.2195C0.799316 19.341 4.369 22.6636 9.10542 22.6636C13.8418 22.6636 17.4115 19.0524 17.4115 14.2195C17.4115 9.38657 14.1497 5.7749 9.10542 5.7749ZM9.10542 19.4433C6.40958 19.4433 4.37817 17.3274 4.37817 14.2195C4.37817 11.1116 6.4945 8.99573 9.10542 8.99573C11.9759 8.99573 13.8327 11.3345 13.8327 14.2195C13.8327 17.1045 11.8674 19.4433 9.10542 19.4433Z" fill="#fff"/>
    <path d="M21.0955 9.36714C19.5022 5.00515 15.4789 1.8012 10.8458 1.20432C10.605 1.16813 10.369 1.36162 10.3522 1.60337L10.1341 4.05361C10.1133 4.2886 10.2812 4.49802 10.5172 4.52986C13.9079 4.99164 16.76 7.28844 17.9605 10.5237C18.0455 10.7549 18.3056 10.8707 18.5285 10.7867L20.8335 9.93073C21.0607 9.84629 21.1785 9.59345 21.0955 9.36714Z" fill="#FFA92C"/>
  </svg>
)

// ─── Erreurs backend /ai/assistant ────────────────────────────────────────────
// Le backend catégorise désormais les erreurs Anthropic (timeout amont, surcharge,
// 5xx, rate limit...) au lieu de renvoyer le message brut (ex: "upstream service
// reached hard timeout") — on ne l'affiche jamais tel quel au client, seulement
// un texte FR adapté à la catégorie.
const AI_ERROR_MESSAGES = {
  timeout: 'Owen met un peu plus de temps que d\'habitude à répondre. Merci de réessayer dans quelques instants.',
  overloaded: 'Owen est momentanément très sollicité. Merci de réessayer dans un instant.',
  rate_limit: 'Trop de demandes en même temps, merci de réessayer dans quelques secondes.',
  server_error: 'Une erreur technique est survenue de notre côté. Merci de réessayer, ou de nous contacter si cela persiste.',
  not_configured: 'Owen n\'est pas disponible pour le moment. Merci de réessayer plus tard.',
  unknown: 'Une erreur inattendue est survenue. Merci de réessayer dans quelques instants.',
}

// ─── Composant ───────────────────────────────────────────────────────────────

const OwenAssistant = ({ userAdhesion: initialUserAdhesion, adhesions: initialAdhesions }) => {
  const navigate = useNavigate()
  const navigateRef = useRef(navigate)
  navigateRef.current = navigate

  // Refs pour accéder aux props dans le useEffect sans le redéclencher
  const userAdhesionRef = useRef(initialUserAdhesion)
  const adhesionsRef   = useRef(initialAdhesions || [])
  userAdhesionRef.current = initialUserAdhesion
  adhesionsRef.current    = initialAdhesions || []

  // ── Co-branding (contractType.coLabeling === 'partner' | 'distributor') ──────
  // `color` (et les couleurs neutres associées) ne sont renseignés par le backend
  // (GET /adhesions/colabel → ClientContext, voir PageWrapper.js) que dans ce cas
  // précis — même source que les modules "Garanties"/"Prix" de l'espace client
  // (composant Card.js). Effet séparé du gros useEffect ci-dessous (qui construit
  // tout le chat de façon impérative) pour rester robuste au chargement async de
  // ce contexte, qui peut résoudre avant ou après le montage du widget.
  const { color, colabelNeutralLight, colabelNeutralDark } = useContext(ClientContext)
  useEffect(() => {
    const root = document.getElementById('owen-bot')
    if (!root) return
    const CB_VARS = ['--cb-accent', '--cb-accent-hover', '--cb-border', '--cb-reply-bg', '--cb-reply-text', '--cb-text', '--cb-dark', '--cb-dot', '--cb-topbar-display', '--cb-ovbar-bg', '--cb-ovbar-fg', '--cb-ovbtn-bg', '--cb-ovbtn-border', '--cb-ovbtn-hover']
    // --p1..--p9 : le dégradé bleu Owen d'origine (voir OwenAssistant.scss). Tout le
    // fichier s'appuie dessus (bulle client, tracker, panneau dossier, badges risque,
    // boutons ghost/info...) — les surcharger directement ici (plutôt que juste les
    // --cb-* dédiés aux 8 points listés au départ) garantit qu'aucun bleu Owen ne
    // subsiste nulle part dans le widget en co-branding, y compris le panel size-lg.
    // Repli sur le même trio déjà utilisé partout ailleurs dans l'app en co-branding
    // (Card.js, NavMenu.js...) : clair -> colabelNeutralLight, foncé -> colabelNeutralDark,
    // accent -> couleur brute du partenaire.
    const P_VARS = {
      '--p1': colabelNeutralLight, '--p2': colabelNeutralLight,
      '--p3': color, '--p4': color, '--p5': color, '--p6': color,
      '--p7': colabelNeutralDark, '--p8': colabelNeutralDark, '--p9': colabelNeutralDark,
    }
    if (color) {
      root.style.setProperty('--cb-accent', color)
      root.style.setProperty('--cb-accent-hover', color)
      root.style.setProperty('--cb-border', color)
      root.style.setProperty('--cb-reply-bg', colabelNeutralLight)
      root.style.setProperty('--cb-reply-text', colabelNeutralDark)
      root.style.setProperty('--cb-text', colabelNeutralDark)
      root.style.setProperty('--cb-dark', colabelNeutralDark)
      root.style.setProperty('--cb-dot', color)
      // Topbar interne (logo Owen + bouton "Déclarer le sinistre") : masquée
      // entièrement en co-branding, un seul bandeau (barre overlay) suffit.
      root.style.setProperty('--cb-topbar-display', 'none')
      // Barre overlay ("Assistant de protection et de sinistre") : fond gris fixe
      // (au lieu de la couleur partenaire) + texte/logo/boutons foncés pour rester
      // lisibles dessus.
      root.style.setProperty('--cb-ovbar-bg', '#ECEEF1')
      root.style.setProperty('--cb-ovbar-fg', colabelNeutralDark)
      root.style.setProperty('--cb-ovbtn-bg', 'rgba(0,0,0,.06)')
      root.style.setProperty('--cb-ovbtn-border', 'rgba(0,0,0,.15)')
      root.style.setProperty('--cb-ovbtn-hover', 'rgba(0,0,0,.12)')
      Object.entries(P_VARS).forEach(([k, v]) => root.style.setProperty(k, v))
    } else {
      // Contrat sans co-branding (ou pas encore résolu) — repasse aux couleurs Owen
      // par défaut définies dans OwenAssistant.scss.
      CB_VARS.forEach(v => root.style.removeProperty(v))
      Object.keys(P_VARS).forEach(v => root.style.removeProperty(v))
    }
  }, [color, colabelNeutralLight, colabelNeutralDark])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let active = true
    const sessionId = Math.random().toString(36).slice(2) + Date.now().toString(36)

    // Données utilisateur issues des props PageWrapper (chargées au login)
    let userAdhesion = userAdhesionRef.current
    let availableNatures = userAdhesion
      ? ((userAdhesion.rateType?.claimNatures?.length > 0 && userAdhesion.rateType.claimNatures) ||
         (userAdhesion.contractType?.claimNatures?.length > 0 && userAdhesion.contractType.claimNatures) || [])
      : []
    let userContext = (adhesionsRef.current || []).map(a => ({
      name: a.rateType?.dashboardPackageName || a.contractType?.dashboardName || a.productName || 'Contrat',
      status: a.adhesionStatus,
      idTransaction: a.idTransaction,
      activationDate: a.activationDate || a.signatureHorodate || null,
      package: a.rateType?.dashboardPackageName || a.rateType?.name || null,
      packageDescription: a.rateType?.dashboardPackageDescription || a.contractType?.dashboardDescription || '',
      claimNatures: (
        (a.rateType?.claimNatures?.length > 0 && a.rateType.claimNatures) ||
        (a.contractType?.claimNatures?.length > 0 && a.contractType.claimNatures) || []
      ).map(n => (typeof n === 'object' ? n.name : n)).filter(Boolean),
      niUrl:   a.contractType?.legalDocuments?.ni   || null,
      fipUrl:  a.contractType?.legalDocuments?.fip  || null,
      ipidUrl: a.contractType?.legalDocuments?.ipid || null,
    }))

    let userFiles = null
    let aiDocFiles = []       // [{ file, pocId, forceAcceptedReason? }] — téléversements par doc en mode IA
    let acknowledgedMismatchIds = new Set() // pocId déjà signalés + confirmés par le client pendant le chat
    let rejectedPocIds = new Set() // pocId dont le dernier envoi a été rejeté par l'IA, en attente d'un nouvel essai
    let aiDocsStarted = false // guard — empêche les déclenchements multiples
    let currentClaimType = null
    let currentClaimNature = null // nom exact de la garantie, renvoyé par l'IA — évite le matching approximatif par mots-clés
    let currentIncident  = null
    let followUpChipsClaimId = null // guard — évite de ré-afficher les chips à chaque tour pour le même dossier

    const CLAIM_TYPE_KEYWORDS = {
      travel_cancellation: ['voyage', 'annulation', 'travel', 'cancel', 'modification'],
      rental_vehicle:      ['location', 'véhicule', 'voiture', 'rental', 'franchise'],
      fraud_identity:      ['fraude', 'hameçonnage', 'phishing', 'bancaire', 'frauduleux'],
      repatriation:        ['rapatriement', 'hospitalisation', 'médical', 'accident', 'santé'],
      layoff:              ['licenciement', 'chômage', 'emploi', 'budget protection', 'maintien de revenus'],
      illness:             ['maladie', 'arrêt', 'incapacité', 'invalidité'],
      business_insolvency: ['cessation', 'faillite', 'insolvabilité', 'liquidation'],
    }

    // ── Helpers API authentifiés ────────────────────────────────────────────
    const apiUrl = config.api.url || ''
    const xApiKey = config.api.xApiKey || ''

    function logAssistantEvent(type, extra = {}) {
      const token = localStorage.getItem('accessToken')
      fetch(`${apiUrl}/ai/assistant/event`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          ...(xApiKey ? { 'x-api-key': xApiKey } : {}),
        },
        body: JSON.stringify({ sessionId, type, adhesionId: userAdhesion?._id || undefined, ...extra }),
      }).catch(() => {})
    }

    function startSession() {
      const token = localStorage.getItem('accessToken')
      fetch(`${apiUrl}/ai/assistant/conversation/start`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          ...(xApiKey ? { 'x-api-key': xApiKey } : {}),
        },
        body: JSON.stringify({ sessionId, adhesionId: userAdhesion?._id || undefined }),
      }).catch(() => {})
    }

    function endSession() {
      const token = localStorage.getItem('accessToken')
      fetch(`${apiUrl}/ai/assistant/conversation/end`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          ...(xApiKey ? { 'x-api-key': xApiKey } : {}),
        },
        body: JSON.stringify({ sessionId, adhesionId: userAdhesion?._id || undefined }),
      }).catch(() => {})
    }

    async function fetchWithAuth(endpoint, options = {}) {
      const token = localStorage.getItem('accessToken')
      const headers = {
        Authorization: `Bearer ${token}`,
        ...(xApiKey ? { 'x-api-key': xApiKey } : {}),
        ...(options.headers || {}),
      }
      const res = await fetch(`${apiUrl}${endpoint}`, { ...options, headers })
      if (!res.ok) throw new Error(`HTTP ${res.status}`)
      const json = await res.json()
      return json?.response ?? json
    }

    const CHK = '<svg viewBox="0 0 12 12" fill="none"><path d="M2 6.5L4.5 9L10 3" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'

    // ── Base de connaissances cover checker ───────────────────────────────
    const COVER_KB = [
      { k: ['annulation','annuler','voyage','séjour','sejour','croisière','croisiere','avion','vol','train','hôtel','hotel'], kcase: 'uc1', a: 'La <strong>garantie annulation voyage</strong> peut s\'appliquer si le voyage a été réglé avec votre carte assurée et que l\'annulation résulte d\'un motif couvert (maladie, hospitalisation d\'un proche…). Souhaitez-vous que je vérifie votre situation pas à pas ?' },
      { k: ['location','louer','loueur','voiture','véhicule','vehicule','franchise','europcar','caution','rayure','accrochage'], kcase: 'uc2', a: 'La <strong>garantie véhicule de location</strong> peut couvrir une franchise ou un dommage facturé après restitution, si la location a été réglée avec votre carte et qu\'il s\'agit d\'un <strong>débit définitif</strong> (pas une caution bloquée). Je peux vérifier votre cas ?' },
      { k: ['fraude','phishing','hameçonnage','hameconnage','sms','piratage','usurpation','frauduleux','arnaque','escroquerie'], kcase: 'uc3', a: '🔒 Pour votre sécurité, je ne vous demanderai <strong>jamais</strong> votre mot de passe, votre code, votre cryptogramme (CVV) ni un code SMS.<br><br>La <strong>garantie fraude en ligne</strong> et l\'<strong>assistance usurpation d\'identité</strong> peuvent s\'appliquer après blocage de la carte et signalement à la banque. On vérifie ensemble ?' },
      { k: ['rapatriement','accident','hôpital','hopital','hospitalisé','hospitalise','médical','medical','étranger','etranger','ski','urgence','blessé','blesse','fracture'], kcase: 'uc4', a: 'Votre carte inclut une <strong>assistance voyage / rapatriement</strong>. En cas d\'urgence, suivez d\'abord les consignes de l\'équipe médicale locale. Je peux ouvrir une demande d\'assistance — souhaitez-vous continuer ?' },
      { k: ['plafond','limite','montant','maximum','combien','indemnité','indemnisation','remboursement'], a: 'Les indemnisations sont <strong>plafonnées</strong> selon votre programme (ex. 1 500 € annulation, 750 € location, 500 € fraude). La perte indemnisable est calculée après déduction des remboursements déjà perçus, et versée sur votre IBAN vérifié.' },
      { k: ['document','justificatif','pièce','piece','papier','facture','preuve','délai','delai','30 jours'], a: 'Selon le sinistre : réservations, preuves d\'annulation/remboursement, facture, justificatif médical, IBAN… Vous avez <strong>30 jours</strong> pour compléter les pièces manquantes.' },
    ]

    const SYSTEM_PROMPT_BASE = `Tu es un assistant spécialisé dans les garanties d'assurance SWAN Protection PREMIUM. Tu parles comme un conseiller humain bienveillant : tu vulgarises, tu reformules, tu n'utilises jamais le langage juridique brut de la notice. Ton objectif est d'aider le client à comprendre sa situation et, si possible, de l'accompagner dans sa déclaration de sinistre.

RÈGLE ABSOLUE DE SÉCURITÉ : Ne jamais demander ni accepter mot de passe, PIN, CVV ou OTP. Si l'utilisateur en saisit un, masque-le et affiche une alerte sécurité.

## TES DEUX MISSIONS

### MISSION 1 — Vérifier la couverture
1. Identifier quelle garantie est potentiellement concernée.
2. Poser des questions simples et ciblées pour vérifier les conditions clés (carte active ? voyage payé avec la carte SWAN ? délais respectés ? situation exclue ?).
3. Quand tu poses une question de vérification, explique toujours brièvement pourquoi. Le client ne doit jamais se sentir interrogé sans comprendre la raison.
4. Mémorise tout ce que le client a déjà mentionné. Ne redemande jamais une information déjà fournie. Si tu dois confirmer, reformule : "Vous m'avez indiqué X, c'est bien ça ?"
5. Dès que tu identifies la garantie applicable, ta phrase de confirmation doit toujours rappeler ensemble les trois éléments suivants : (1) le nom de la garantie, (2) le montant maximum possible, et (3) une reformulation courte de la situation concrète du client (ex : "Pour votre vol retardé de 5h à Lisbonne, cela correspond à la garantie Retard de transport, avec un remboursement possible jusqu'à 400 €"). Ne parle jamais de montant garanti, toujours de montant maximum possible.
6. Indique clairement : ✅ semble couvert / ❌ non couvert / ⚠️ potentiellement couvert mais un point est à vérifier.
7. Ne confirme jamais définitivement une couverture, et n'utilise jamais de formulation catégorique comme "vous êtes couvert(e)(s)" ou "c'est pris en charge". Utilise systématiquement une formulation conditionnelle : "être susceptible de", "pouvoir", "peut s'appliquer", "sous réserve de validation par l'équipe sinistres"... Dis toujours : "Votre situation semble correspondre à la garantie X — mais c'est un agent de notre équipe sinistres qui confirmera définitivement la prise en charge après analyse de votre dossier."
8. Si la situation semble couverte → passer automatiquement à la Mission 2.

### MISSION 2 — Prendre en charge la déclaration de sinistre
Étape 1 — Collecte les 4 éléments suivants. Si l'un manque, redemande-le :
- La date du sinistre
- Le lieu du sinistre
- La garantie concernée (tu peux la nommer toi-même si c'est évident)
- Une description claire de ce qui s'est passé

⚠️ Dès que tu disposes à la fois de la garantie concernée ET de la date du sinistre — même si le lieu ou la description manquent encore — applique immédiatement les RÈGLES DE VALIDATION DES DATES ci-dessous, avant de continuer à collecter les éléments restants. Ne demande jamais le lieu ou la description tant que la date n'a pas été validée : si elle est invalide, inutile de faire décrire le reste au client.

Étape 2 — Présente un récapitulatif clair de la situation, indique dans la même réponse les justificatifs prioritaires à rassembler pour sa garantie (voir liste JUSTIFICATIFS PRIORITAIRES PAR GARANTIE ci-dessous, avec une brève explication de l'utilité de chacun), puis demande une seule confirmation qui couvre à la fois l'exactitude des informations et la volonté de formaliser la déclaration (ex : "Ces informations sont-elles correctes ? Si oui, j'enregistre votre déclaration et vous pourrez ensuite téléverser ces justificatifs directement dans le chat.").

Étape 3 — Dès que le client confirme une seule fois (informations correctes / volonté de formaliser sa déclaration) → pose "complete_claim": true dans ta réponse JSON. Ne redemande jamais une seconde confirmation distincte ("êtes-vous prêt(e) ?", "voulez-vous valider ?"...) : la confirmation de l'Étape 2 suffit.

### CAS PARTICULIER — Client perdu ou hésitant
Si le client semble confus ou hésite, accompagne-le directement : "Pas de souci, décrivez-moi simplement ce qui s'est passé. Un agent sinistre humain analysera votre dossier et vous répondra sous 24h." Collecte quand même les 4 éléments et génère le récapitulatif.

### CAS PARTICULIER — Exclusion potentielle détectée
Même si une exclusion potentielle est détectée, ne bloque jamais le client. Signale le risque de façon bienveillante, puis propose systématiquement d'ouvrir quand même une déclaration. Un agent humain tranchera définitivement sous 24h. Ne pose jamais de questions du type "Saviez-vous que..." ou "Étiez-vous au courant que...".

### CAS PARTICULIER — Destination déconseillée par le MAE
Dès qu'un client mentionne une destination, vérifie si elle est potentiellement déconseillée par le Ministère des Affaires Étrangères français (zones de conflit actif : Israël, Ukraine, etc.). Signale ce risque d'exclusion de façon bienveillante, puis propose quand même d'ouvrir une déclaration. Invite le client à vérifier sur diplomatie.gouv.fr.

### CAS PARTICULIER — Client demande à modifier un justificatif déjà transmis
Si le client demande à changer, remplacer, corriger ou renvoyer un document qu'il a déjà transmis pour un sinistre en cours (justificatif accepté ou déjà en cours d'analyse par notre équipe), tu ne peux jamais réaliser ce changement toi-même, même si le client insiste, reformule sa demande, ou affirme avoir déjà envoyé un nouveau fichier. N'affirme JAMAIS qu'un document a été remplacé, mis à jour ou modifié — que ce soit dans l'immédiat ou "en cours de traitement" : aucun fichier ne t'est jamais transmis dans cette conversation. Indique simplement que ce changement n'est pas possible directement dans le chat, et qu'un conseiller de notre équipe sinistres reviendra vers lui pour organiser le remplacement du document. Cette règle ne concerne pas les justificatifs encore manquants ou refusés : pour ceux-là, le téléversement via le bouton dédié reste possible normalement.

### RÈGLES DE VALIDATION DES DATES
La date du jour t'est fournie dans le contexte (section "DATE DU JOUR" ci-dessous). Dès que tu connais à la fois la garantie concernée et la date de l'incident donnée par le client (voir rappel dans MISSION 2), vérifie immédiatement cette date, sans attendre les autres éléments :

- **Si cette date est POSTÉRIEURE à aujourd'hui (dans le futur)** : signale-le clairement, sans dramatiser — c'est une simple constatation, pas une mauvaise nouvelle. Demande au client de confirmer la date exacte de l'événement à déclarer : selon la garantie, la date pertinente n'est pas toujours celle à laquelle on pense spontanément (par exemple, pour un retard ou une annulation de transport, c'est la date du retard/de l'annulation elle-même, pas une démarche postérieure). Si le client confirme malgré tout une date future, ou souhaite continuer sans la corriger, ne bloque pas la déclaration : poursuis la collecte des éléments restants et indique clairement qu'un agent de notre équipe sinistres traitera le dossier et vérifiera ce point.

- **Si cette date est dans le passé mais que le délai écoulé depuis dépasse le délai de déclaration propre à la garantie identifiée** (délais indiqués dans GARANTIES ET CONDITIONS ci-dessous) : signale-le clairement, sans dramatiser. Demande au client de bien confirmer la date du sinistre, au cas où il se serait trompé. Si le client confirme la date (ou insiste pour continuer malgré le délai dépassé), ne bloque jamais la déclaration : poursuis la collecte des éléments restants et indique clairement qu'un agent de notre équipe sinistres traitera le dossier et tranchera sur la recevabilité malgré le délai. Mentionne customer@getowen.eu comme option si le client préfère écrire directement plutôt que de continuer dans le chat.

Dans les deux cas : jamais de blocage définitif de la déclaration si le client souhaite poursuivre — le rôle de l'agent est de signaler le point d'attention, pas de trancher ou d'empêcher la déclaration.

## GARANTIES ET CONDITIONS (VERSION VULGARISÉE)

1. **Perte ou Vol de papiers d'identité** — jusqu'à 350 €/an. Carte SWAN PREMIUM active au moment des faits. Remboursé : frais pour refaire ses papiers. Délai : 30 jours ouvrables.

2. **Utilisation frauduleuse de la carte** — jusqu'à 3 000 €/an. Carte utilisée sans autorisation avant opposition. Non couvert : proche de la famille, code PIN utilisé, après opposition. Délai : 2 jours ouvrables pour prévenir SWAN, puis 30 jours pour déclarer.

3. **Hameçonnage (phishing)** — jusqu'à 1 000 €/an (seulement si préjudice > 50 €). Arnaque en ligne, SWAN doit avoir refusé le remboursement. Non couvert : sites illégaux, après opposition. Délai : opposition immédiate, prévenir SWAN sous 2 jours ouvrables.

4. **Retard ou annulation de transport** — jusqu'à 400 € par incident. Voyage payé avec la carte, retard > 4h (vol/train régulier) ou > 6h (charter), ou annulation/surbooking. Non couvert : retards annoncés 24h avant. Délai : 15 jours.

5. **Retard de bagages** — jusqu'à 800 € par incident. Bagages enregistrés arrivés > 4h après le client, voyage payé avec la carte, ne s'applique pas au retour. Délai : 15 jours.

6. **Perte, vol ou détérioration des bagages** — jusqu'à 800 € / bagage (franchise 70 €). Bagages enregistrés et confiés au transporteur, voyage payé avec la carte. Objets de valeur couverts jusqu'à 250 € pièce. Non couvert : lunettes, prothèses, papiers, argent, cartes bancaires, usure normale, animaux. Délai : 15 jours.

7. **Annulation ou modification de voyage** — jusqu'à 5 000 €/an. Voyage payé avec la carte, annulation due à : maladie/blessure grave, décès dans la famille proche, sinistre au domicile, licenciement économique, mutation imposée, suppression de congés validés. Non couvert : état anxieux/dépressif sans hospitalisation ≥ 3 jours, maladie connue hospitalisée dans les 6 mois avant l'achat. Délai : annuler auprès du prestataire dans les 72h.

8. **Véhicule de location** — jusqu'à 2 sinistres/an (vol limité à 30 000 €). Loué chez un professionnel, payé avec la carte, durée ≤ 31 jours, nom de l'assuré sur le contrat, voyage professionnel. Non couvert : particuliers, véhicules de luxe (Ferrari, Porsche, Lamborghini, Rolls-Royce…), alcool/drogues, dommages volontaires. Délai : 15 jours.

9. **Frais de secours sur pistes (ski)** — jusqu'à 1 000 €/an. Accident sur piste balisée, séjour > 50 km du domicile, forfait/hébergement/transport payé avec la carte, pratique amateur. Non couvert : malaise/maladie sans accident, ski hors-piste. Délai : 15 jours.

## SERVICES D'ASSISTANCE (Allianz Partners)
⚠️ Ces services sont distincts des 9 garanties d'assurance ci-dessus. Si un client demande "quelles assistances sont incluses" ou "qu'est-ce qui est couvert en assistance", réponds uniquement à partir de la liste ci-dessous — ne mélange jamais avec les garanties, et n'invente ou n'approximes jamais un service qui n'y figure pas.

**Assistance voyage (Allianz Partners)** — disponible 24h/24.
Couvre notamment :
- Rapatriement médical
- Avance de fonds à l'étranger
- Assistance en cas d'hospitalisation
- Retour anticipé en cas d'urgence familiale
- Envoi de médicaments urgents
- Assistance juridique à l'étranger et remboursement de frais d'avocat à l'étranger

Conditions :
- Déplacement professionnel
- Franchise de 100 km depuis la résidence ou le lieu de travail pour les événements survenant dans le pays de résidence (aucune franchise à l'étranger)
- Séjour inférieur à 90 jours consécutifs (sauf conditions spécifiques)

Non couvert : voyages vers des destinations déconseillées par le MAE français.

**Règle essentielle à rappeler systématiquement** : dès qu'un sinistre est susceptible d'impliquer l'assistance, rappelle au client qu'il doit contacter Allianz Assistance AVANT d'engager la moindre dépense. Toute dépense engagée sans l'accord préalable d'Allianz ne sera pas remboursée.

Contact urgence : +33 1 70 39 12 19 (24h/24).

## EXCLUSIONS COMMUNES
- Acte intentionnel ou frauduleux du client
- Guerre, conflit armé
- Contamination nucléaire, biologique ou chimique
- Participation à des actes illégaux
- Voyage vers une destination déconseillée par le MAE français

## JUSTIFICATIFS PRIORITAIRES PAR GARANTIE
- Perte/Vol papiers : dépôt de plainte + justificatifs des frais
- Fraude carte : opérations contestées + refus SWAN + dépôt de plainte + preuve opposition
- Phishing : refus SWAN + captures e-mails/SMS suspects + dépôt de plainte
- Retard transport/annulation : extrait de compte + billets + attestation transporteur
- Retard bagages : extrait de compte + billets + attestation retard + bordereau remise bagages
- Perte/Vol bagages : extrait de compte + billet de transport
- Annulation voyage : extrait de compte ou attestation SWAN + billets ou réservations
- Véhicule location : extrait de compte + contrat de location et facture
- Secours ski : extrait de compte + billets/réservation séjour + facture premier transport

## RÈGLES DE TON
- Parle comme un conseiller humain, pas comme un texte de contrat.
- Ne copie jamais mot pour mot un article de la notice.
- Reformule toujours les conditions en langage simple et direct.
- Privilégie toujours le présent de l'indicatif plutôt que le futur ou le conditionnel (ex : "je vérifie", "cela correspond" plutôt que "je vais vérifier", "cela correspondrait").
- Sois poli et direct : chaque phrase doit servir à faire comprendre la situation ou à faire avancer la déclaration. Évite les formules de politesse creuses ou les marques d'empathie systématiques ("désolé d'apprendre cela", "je comprends que ce soit difficile"...) — la clarté et l'efficacité priment sur la chaleur artificielle.
- Utilise toujours "indemnisation", "remboursement" ou "prise en charge" pour parler du dénouement d'un sinistre — jamais "paiement" ou "payer", qui laissent penser à tort à un versement automatique ou immédiat plutôt qu'à une décision de l'assureur après analyse du dossier.
- Tu ne confirmes jamais définitivement une indemnisation : c'est l'assureur qui tranche.
- Même en cas d'exclusion potentielle, propose toujours d'ouvrir une déclaration.
- Un agent de notre équipe sinistres répond sous 24h après réception du dossier.
- Si le client demande une action que tu ne peux pas effectuer toi-même (modification de contrat, opposition de carte, remboursement, changement de coordonnées, remplacement d'un justificatif déjà transmis, etc.), ne fais jamais semblant de l'exécuter et n'improvise pas de solution. Indique succinctement que tu ne peux pas réaliser cette action, puis redirige vers customer@getowen.eu ou propose une prise de rendez-vous ("propose_rdv": true) selon le cas.

## OPTIONS SUPPLÉMENTAIRES DISPONIBLES (upsell)
Si le client demande s'il peut renforcer sa couverture ou souscrire une option supplémentaire, ou si tu identifies un besoin qu'aucune garantie actuelle ne couvre, présente les offres suivantes (à titre indicatif — la souscription se fait toujours avec un conseiller) :
- **Annulation voyage toutes causes** — annulable jusqu'à 48h avant le départ, remboursement de 70 % du montant du séjour sans justification à fournir. Prix indicatif : 1 % du montant du voyage.
- **Assurance toutes locations sur place** — prend en charge les cautions en cas de casse ou de vol des équipements loués pendant le séjour (vélo, ski, bateau, surf, van, caravane), en complément de la location de véhicule déjà couverte.
- **Assurance moyens de paiement renforcée** — couvre en plus la perte et le vol des clés et des papiers d'identité.
Dans tous les cas, précise que la souscription nécessite un rendez-vous avec un conseiller Owen, et pose "propose_rdv": true dans ta réponse JSON dès que le client montre de l'intérêt pour une de ces options.

## À TOUT MOMENT — Demande explicite de RDV
Si le client demande explicitement à parler à un conseiller ou à prendre rendez-vous (même hors contexte upsell), pose "propose_rdv": true, quelle que soit l'étape de la conversation.

## CONTACTS UTILES
- Réclamation assurance : customer@getowen.eu
- Assistance urgence voyage (24h/24) : +33 1 70 39 12 19
- Déclaration sinistre : via l'application Owen (espace client)`

    // Bloc J — toujours injecté en dernier, que le prompt vienne de Notion ou du fallback
    const SYSTEM_PROMPT_JSON = `

Réponds UNIQUEMENT en JSON brut (sans markdown, sans backticks) :
{"reply":"message HTML (<strong> autorisé)","claim_type":"travel_cancellation|rental_vehicle|fraud_identity|repatriation|layoff|illness|business_insolvency|other_claim|coverage_question|unknown","claim_nature":"nom EXACT de la garantie tel que listé dans « Natures couvertes » ci-dessous, ou null","propose_rdv":false,"risk":"low|med|high","stage":0,"incident":{"date":"YYYY-MM-DD ou null","location":"ville/pays ou null","amount":"montant en € ou null","description":"résumé détaillé des circonstances (plusieurs phrases si nécessaire, reprend tous les éléments précisés par le client pendant toute la conversation) ou null"},"complete_claim":false,"claim_followup_id":null}

"claim_nature" DOIT reprendre mot pour mot le nom d'une des natures listées dans « Natures couvertes » du contrat du client (jamais une reformulation). Renseigne-le dès que tu identifies la garantie concernée, même avant complete_claim.
"propose_rdv" vaut true quand le client exprime un intérêt pour une option/garantie supplémentaire (upsell), ou demande explicitement à parler à un conseiller / prendre rendez-vous. Sinon false.
"complete_claim" vaut true UNIQUEMENT quand : (1) les 4 éléments de déclaration sont collectés, (2) le récapitulatif ET les justificatifs nécessaires (s'il y en a) ont été présentés ensemble au client, (3) le client a confirmé une seule fois (accord sur les informations + volonté de formaliser). À tout autre moment → false. Ne redemande jamais une seconde confirmation distincte après celle-ci. Ne mentionne jamais de téléversement si aucun justificatif n'est défini.
Utilise "layoff" pour licenciement économique, "illness" pour arrêt maladie, "business_insolvency" pour cessation de paiement, "other_claim" pour tout autre sinistre réel.

"claim_followup_id" : dès que le client s'informe sur un sinistre DÉJÀ déclaré (statut, avancement, justificatifs manquants — quelle que soit la formulation), regarde la section "SINISTRES EN COURS DU CLIENT" ci-dessous. Si un seul dossier ouvert y figure, ou si tu identifies clairement de quel dossier il parle, renseigne son "id" exact tel que listé. Sinon (aucun dossier ouvert, ou ambiguïté entre plusieurs dossiers non résolue par la conversation) laisse null. Ne renseigne JAMAIS un id qui ne figure pas explicitement dans cette section — ne l'invente jamais.`

    // REACT_APP_OWEN_ASSISTANT_PROMPT_SOURCE=notion|hardcoded (défaut: hardcoded)
    const PROMPT_SOURCE = (process.env.REACT_APP_OWEN_ASSISTANT_PROMPT_SOURCE || 'hardcoded').toLowerCase()

    async function fetchSystemPrompt() {
      if (PROMPT_SOURCE !== 'notion') return
      try {
        // adhesionsRef peut ne pas encore être peuplé si le chat s'ouvre avant la fin du
        // chargement des adhésions (course au montage) : on attend jusqu'à 5s avant d'abandonner.
        for (let i = 0; i < 25 && !(adhesionsRef.current || []).length; i++) {
          await new Promise(r => setTimeout(r, 200))
        }

        const contractTypeIds = [...new Set(
          (adhesionsRef.current || [])
            .map(a => a.contractType?._id || a.contractType)
            .filter(Boolean)
            .map(String)
        )]
        if (!contractTypeIds.length) {
          console.warn('[Owen assistant] fetchSystemPrompt: adhesionsRef toujours vide après 5s')
          return
        }

        const parts = await Promise.all(
          contractTypeIds.map(id =>
            fetchWithAuth(`/ai/assistant/system-prompt?contractTypeId=${id}`)
              .then(d => d?.prompt || null)
              .catch(() => null)
          )
        )
        const valid = parts.filter(Boolean)
        if (!valid.length) return

        NOTION_CONTENT = valid.length === 1
          ? valid[0]
          : valid.map((p, i) => `## Contrat ${i + 1}\n${p}`).join('\n\n---\n\n')
      } catch (e) {
        console.warn('[Owen assistant] fetchSystemPrompt:', e.message)
      }
    }

    // Sinistres ouverts + justificatifs manquants du client — injectés dans le system prompt
    // (voir buildSystemPrompt) pour que l'IA connaisse toujours l'état réel, quelle que soit la
    // formulation du client, au lieu de deviner ou de répondre qu'elle ne peut rien faire.
    async function fetchOpenClaimsContext() {
      try {
        const claims = await fetchClientClaims()
        const openClaims = claims.filter(c => c?.status && !c.status.startsWith('Closed'))
        OPEN_CLAIMS_RAW = openClaims
        if (!openClaims.length) { OPEN_CLAIMS_CONTEXT = ''; return }

        OPEN_CLAIMS_CONTEXT = openClaims.map(claim => {
          const id = String(claim._id)
          const ref = claim.shortId || id.slice(-8)
          const nature = claim.nature?.name || 'sinistre'
          const missing = getMissingProofs(claim)
          const missingLabel = missing.length
            ? `Justificatifs manquants : ${missing.map(p => p.name).join(', ')}`
            : 'Aucun justificatif manquant'
          const incidentDate = claim.incidentDate
            ? new Date(claim.incidentDate).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
            : null
          let line = `- id: ${id} · Dossier ${ref} — ${nature} · Statut : ${claim.status} · ${missingLabel}`
          if (incidentDate) line += `\n  Date du sinistre : ${incidentDate}`
          if (claim.location) line += `\n  Lieu : ${claim.location}`
          if (claim.circumstance) line += `\n  Circonstances déjà fournies par le client : ${claim.circumstance}`
          return line
        }).join('\n')
      } catch (e) {
        console.warn('[Owen assistant] fetchOpenClaimsContext:', e.message)
      }
    }

    function buildSystemPrompt() {
      const clientName = userAdhesion
        ? `${userAdhesion.firstname || ''} ${userAdhesion.lastname || ''}`.trim()
        : null
      const contractLabel = userAdhesion
        ? (userAdhesion.rateType?.dashboardPackageName || userAdhesion.contractType?.dashboardName || 'Garantie carte premium')
        : 'Garantie carte premium'
      const natures = availableNatures.map(n => typeof n === 'object' ? n.name : n).filter(Boolean).join(', ')

      // PROMPT_SOURCE=notion → NOTION_CONTENT remplace entièrement SYSTEM_PROMPT_BASE si présent (OU exclusif)
      // PROMPT_SOURCE=hardcoded (défaut) → NOTION_CONTENT n'est jamais rempli, on reste sur SYSTEM_PROMPT_BASE
      // SYSTEM_PROMPT_JSON (Bloc J) est toujours injecté en dernier — format JSON critique
      let prompt = (NOTION_CONTENT || SYSTEM_PROMPT_BASE) + SYSTEM_PROMPT_JSON

      // Garde-fou résilient au prompt Notion (même principe que le Bloc J ci-dessus) — évite
      // qu'un contrat passé en prompt Notion perde cette règle liée à l'intégrité de l'info client.
      prompt += `\n\n## RÈGLE ABSOLUE — Modification d'un justificatif déjà transmis\nSi le client demande à changer, remplacer ou corriger un document déjà transmis pour un sinistre en cours (accepté ou en cours d'analyse), ne confirme jamais que ce changement a été effectué — tu ne reçois jamais de fichier dans cette conversation. Indique que ce n'est pas possible directement dans le chat et qu'un conseiller de notre équipe sinistres reviendra vers lui pour ce changement de document. Cette règle ne s'applique pas aux justificatifs encore manquants ou refusés, pour lesquels le téléversement via le bouton dédié reste normal.`

      // Date du jour — nécessaire aux RÈGLES DE VALIDATION DES DATES (rejet des dates futures / délais dépassés)
      const todayStr = new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
      prompt += `\n\n## DATE DU JOUR\nNous sommes le ${todayStr}. Utilise cette date pour toute vérification de délai ou de cohérence temporelle.`

      // Injection dynamique des proofOfClaims par nature — source unique (DB)
      const naturesWithDocs    = availableNatures.filter(n => typeof n === 'object' && n.proofOfClaims?.length)
      const naturesWithoutDocs = availableNatures.filter(n => typeof n === 'object' && !n.proofOfClaims?.length && n.name)
      if (naturesWithDocs.length || naturesWithoutDocs.length) {
        prompt += '\n\n## JUSTIFICATIFS PAR NATURE DE SINISTRE\n'
        if (naturesWithDocs.length) {
          prompt += 'À l\'Étape 2, liste EXACTEMENT les justificatifs ci-dessous selon la nature identifiée, dans la même réponse que le récapitulatif. Ne pose complete_claim: true qu\'APRÈS avoir listé ces documents ET obtenu cette confirmation unique du client.\n'
          naturesWithDocs.forEach(n => {
            prompt += `\n### ${n.name}\n`
            n.proofOfClaims.filter(p => p && p.name).forEach(poc => {
              prompt += `- ${poc.name}\n`
            })
          })
        }
        if (naturesWithoutDocs.length) {
          prompt += '\n\n⚠️ RÈGLE ABSOLUE pour les natures suivantes (aucun justificatif en ligne) : '
          prompt += naturesWithoutDocs.map(n => n.name).join(', ')
          prompt += '.\n'
          prompt += '- NE mentionne JAMAIS de téléversement, de documents à joindre, ni de "pièces à fournir en ligne".\n'
          prompt += '- À l\'Étape 2 : dis uniquement "Un agent de notre équipe vous contactera pour vous préciser les justificatifs nécessaires."\n'
          prompt += '- Pose complete_claim: true dès que le client confirme vouloir formaliser sa déclaration (sans condition de téléversement).\n'
        }
      }

      // Contexte client complet — toutes les adhésions avec date début + formule
      const allAdhesions = adhesionsRef.current || []
      if (clientName || allAdhesions.length) {
        prompt += '\n\n## Assuré connecté (données certifiées — NE PAS redemander)'
        if (clientName) prompt += `\nNom : ${clientName}`
        allAdhesions.forEach((a, i) => {
          const label = a.rateType?.dashboardPackageName || a.contractType?.dashboardName || a.productName || 'Contrat'
          const dateRef = a.activationDate || a.signatureHorodate
          const activDate = dateRef
            ? new Date(dateRef).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
            : null
          const pkg = a.rateType?.dashboardPackageName || a.rateType?.name
          const desc = a.rateType?.dashboardPackageDescription
          const aNatures = (
            (a.rateType?.claimNatures?.length > 0 && a.rateType.claimNatures) ||
            (a.contractType?.claimNatures?.length > 0 && a.contractType.claimNatures) || []
          ).map(n => typeof n === 'object' ? n.name : n).filter(Boolean).join(', ')
          const prefix = allAdhesions.length > 1 ? `\nContrat ${i + 1} — ` : '\nContrat — '
          prompt += `${prefix}**${label}**`
          if (activDate) prompt += ` · Début : ${activDate}`
          if (a.adhesionStatus) prompt += ` · Statut : ${a.adhesionStatus}`
          if (pkg) prompt += ` · Formule : ${pkg}`
          if (desc) prompt += ` (${desc})`
          if (aNatures) prompt += `\n  Natures couvertes : ${aNatures}`
        })
        prompt += '\n\nNe redemande jamais la date de début du contrat, la formule souscrite, ni le statut — ces données sont déjà connues et vérifiées.'
      }

      // Sinistres en cours — données certifiées (GET /claims), remplies en amont par
      // fetchOpenClaimsContext(). Empêche l'IA d'inventer un statut ou "aucun sinistre"
      // sans avoir la vraie donnée, quelle que soit la formulation du client.
      prompt += '\n\n## SINISTRES EN COURS DU CLIENT (données certifiées — ne jamais inventer un statut différent)\n'
      prompt += OPEN_CLAIMS_CONTEXT || 'Aucun sinistre en cours trouvé pour ce client.'
      prompt += '\n\nCes informations sont déjà connues et vérifiées. Si le client demande où en est un dossier listé ci-dessus, réponds directement avec son statut, sa date, son lieu et ses circonstances déjà fournies — ne redemande JAMAIS une information déjà présente ici (date du sinistre, lieu, circonstances), et n\'invente JAMAIS une information absente : si un champ n\'est pas listé, dis simplement que tu ne l\'as pas plutôt que de le deviner.'

      return prompt
    }

    // ── Références DOM ────────────────────────────────────────────────────
    const root   = document.getElementById('owen-bot')
    const fab    = document.getElementById('ob-fab')
    const ovl    = document.getElementById('ob-overlay')
    const btnClose  = document.getElementById('ob-ovclose')
    const btnToggle = document.getElementById('ob-toggle')
    const logEl   = document.getElementById('log')
    const quickEl = document.getElementById('quick')
    const suggEl  = document.getElementById('composer-suggestions')
    const comp    = document.getElementById('composer')
    const ci      = document.getElementById('composer-input')
    const btnDownloadTranscript = document.getElementById('ob-download-transcript')
    let NOTION_CONTENT = ''
    let OPEN_CLAIMS_CONTEXT = ''
    let OPEN_CLAIMS_RAW = []
    let currentSystemPrompt = SYSTEM_PROMPT_BASE
    const convo = []
    let closeInfoTooltipOnOutsideClick = null

    function clearSuggestions() {
      if (suggEl) suggEl.innerHTML = ''
    }

    // ── Overlay open/close/toggle ─────────────────────────────────────────
    function openOverlay() {
      ovl.hidden = false
      fab.style.display = 'none'
      if (root.classList.contains('size-lg')) document.body.style.overflow = 'hidden'
      // Resync depuis les refs au cas où les props auraient changé après le mount
      if (!userAdhesion && userAdhesionRef.current) {
        userAdhesion = userAdhesionRef.current
        availableNatures = (
          (userAdhesion.rateType?.claimNatures?.length > 0 && userAdhesion.rateType.claimNatures) ||
          (userAdhesion.contractType?.claimNatures?.length > 0 && userAdhesion.contractType.claimNatures) || []
        )
      }
    }

    function closeOverlay() {
      endSession()
      ovl.hidden = true
      fab.style.display = 'flex'
      document.body.style.overflow = ''
    }

    // Icône ℹ️ discrète insérée dans le texte du message d'ouverture (pas un bouton à part).
    // Le panneau qu'elle ouvre (#ob-ai-info-tooltip) vit HORS du fil de messages (dans le JSX de
    // .chat), pas dans la bulle — sinon l'animation oa-rise des bulles crée un nouveau contexte
    // d'empilement par message et le tooltip se retrouve visuellement sous les bulles suivantes
    // au lieu d'être superposé par-dessus.
    const AI_INFO_ICON_HTML = '<button type="button" class="ob-info-icon" id="ob-ai-info-icon" aria-label="En savoir plus" title="En savoir plus"><svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.6"/><circle cx="10" cy="6.2" r="1.15" fill="currentColor"/><path d="M10 9.3V14.3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>'

    function wireAiInfoTooltip() {
      const icon = document.getElementById('ob-ai-info-icon')
      const tooltip = document.getElementById('ob-ai-info-tooltip')
      const body = document.getElementById('ob-ai-info-body')
      const closeBtn = document.getElementById('ob-ai-info-close')
      const humanBtn = document.getElementById('ob-ai-info-human-btn')
      const chatEl = icon.closest('.chat') || document.querySelector('#ob-asst .chat')
      if (!icon || !tooltip || !chatEl) return

      // #ob-overlay a overflow:hidden (coins arrondis) : si le tooltip dépasse son bord bas, il
      // est rogné silencieusement. On calcule donc la place réellement dispo sous l'icône dans
      // l'overlay, et le corps du tooltip (.ob-info-body) scrolle en interne au lieu d'être coupé.
      function positionTooltip() {
        const iconRect = icon.getBoundingClientRect()
        const chatRect = chatEl.getBoundingClientRect()
        const overlayRect = ovl.getBoundingClientRect()
        const tooltipWidth = 240
        let left = iconRect.left - chatRect.left
        left = Math.min(left, chatRect.width - tooltipWidth - 12)
        left = Math.max(left, 12)
        tooltip.style.left = `${left}px`
        tooltip.style.top = `${iconRect.bottom - chatRect.top + 8}px`
        if (body) {
          const available = overlayRect.bottom - iconRect.bottom - 8 /* gap */ - 40 /* marge de sécurité */
          body.style.maxHeight = `${Math.max(140, available)}px`
        }
      }

      icon.onclick = e => {
        e.stopPropagation()
        if (tooltip.hidden) { positionTooltip(); tooltip.hidden = false } else { tooltip.hidden = true }
      }
      if (closeBtn) closeBtn.onclick = e => { e.stopPropagation(); tooltip.hidden = true }
      if (humanBtn) {
        humanBtn.onclick = e => {
          e.stopPropagation()
          tooltip.hidden = true
          optOutToHuman()
        }
      }
      closeInfoTooltipOnOutsideClick = e => {
        if (!tooltip.hidden && e.target !== icon && !tooltip.contains(e.target)) tooltip.hidden = true
      }
      document.addEventListener('click', closeInfoTooltipOnOutsideClick)
    }

    // Opt-out vers un conseiller humain — déclenché depuis le tooltip d'info.
    function optOutToHuman() {
      clearChips()
      bubble('bot', 'Pas de souci — un conseiller Owen peut prendre le relais. Vous pouvez réserver un créneau directement ci-dessous.')
      appendRdvButton()
    }

    // Bouton inline "Prendre RDV" — utilisé pour l'opt-out et pour l'upsell/demande de RDV en cours de conversation IA
    function appendRdvButton() {
      const rdvUrl = process.env.REACT_APP_OWEN_RDV_URL || 'https://calendar.google.com/'
      const btnWrap = document.createElement('div')
      btnWrap.className = 'msg-inline-action'
      btnWrap.innerHTML = '<button class="inline-cta">📅 Prendre rendez-vous avec un conseiller</button>'
      btnWrap.querySelector('button').onclick = () => { window.open(rdvUrl, '_blank', 'noopener') }
      logEl.appendChild(btnWrap)
      scrollLog()
    }

    function setLarge(big) {
      root.classList.toggle('size-lg', big)
      root.classList.toggle('size-sm', !big)
      document.body.style.overflow = (big && !ovl.hidden) ? 'hidden' : ''
      updatePlaceholder()
      try { window.dispatchEvent(new Event('resize')) } catch (e) {}
    }

    function updatePlaceholder() {
      if (ci) ci.placeholder = root.classList.contains('size-sm') ? 'Poser une question…' : 'Posez votre question…'
    }

    fab.onclick = openOverlay
    btnClose.onclick = closeOverlay
    btnToggle.onclick = () => setLarge(root.classList.contains('size-sm'))
    if (btnDownloadTranscript) btnDownloadTranscript.onclick = downloadTranscript
    updatePlaceholder()

    // ── Helpers chat ──────────────────────────────────────────────────────
    function md(s) {
      return String(s ?? '').replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    }

    function escHtml(s) {
      return String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    }

    // Empreinte du contenu du fichier — détecte un même fichier réutilisé pour deux justificatifs
    // différents (l'IA vision ne le voit pas : elle juge chaque fichier isolément, sans mémoire des autres).
    // SubtleCrypto exige un contexte sécurisé (HTTPS/localhost) ; en dev sur IP LAN (http://172.x.x.x)
    // il est absent, d'où le repli sur nom+taille+date, moins robuste mais suffisant pour détecter un
    // même fichier resélectionné tel quel.
    async function hashFile(file) {
      try {
        if (crypto?.subtle) {
          const buf = await file.arrayBuffer()
          const digest = await crypto.subtle.digest('SHA-256', buf)
          return Array.from(new Uint8Array(digest)).map(b => b.toString(16).padStart(2, '0')).join('')
        }
      } catch (e) { /* repli ci-dessous */ }
      return `${file.name}_${file.size}_${file.lastModified}`
    }

    function scrollLog() { logEl.scrollTop = logEl.scrollHeight }

    function bubble(cls, html) {
      const d = document.createElement('div')
      d.className = 'msg ' + cls
      d.innerHTML = md(html)
      logEl.appendChild(d)
      scrollLog()
      return d
    }


    function chips(list) {
      quickEl.innerHTML = ''
      list.forEach(o => {
        const b = document.createElement('button')
        b.className = 'chip' + (o.cta ? ' cta' : '') + (o.ghost ? ' ghost' : '')
        b.innerHTML = md(o.l)
        b.onclick = () => {
          if (o.nav) { navigateRef.current(o.href); return }
          if (o.noecho !== true) bubble('user', escHtml(o.l))
          o.fn && o.fn()
        }
        quickEl.appendChild(b)
      })
    }

    function clearChips() { quickEl.innerHTML = '' }



    function botSayRaw(msgs, done, withTyping) {
      let i = 0
      ;(function nx() {
        if (!active || i >= msgs.length) { if (active) done && done(); return }
        const m = msgs[i]
        if (withTyping) {
          const t = document.createElement('div')
          t.className = 'typing'
          t.innerHTML = '<span></span><span></span><span></span>'
          logEl.appendChild(t)
          scrollLog()
          const delay = Math.max(1800, Math.min(4000, 1000 + m.length * 22))
          setTimeout(() => {
            if (!active) return
            t.remove(); bubble('bot', m); i++; nx()
          }, delay)
        } else {
          bubble('bot', m); i++
          setTimeout(nx, 180)
        }
      })()
    }

    function botSay(msgs, done)     { botSayRaw(msgs, done, true) }
    function botSayFast(msgs, done) { botSayRaw(msgs, done, false) }

    // ── Helpers dossier ───────────────────────────────────────────────────
    function trackTo(n) {
      document.querySelectorAll('#track-body .tstep').forEach((el, i) => {
        el.classList.remove('active', 'done')
        if (i < n) el.classList.add('done')
        else if (i === n) el.classList.add('active')
      })
    }

    function scrollDossier() {
      const ds = document.getElementById('dossier')
      if (ds) ds.scrollTop = ds.scrollHeight
    }

    // ── Mise à jour dossier en temps réel (mode IA libre) ────────────────
    function updateDossierFromAI() {
      const inc = currentIncident || {}
      const type = currentClaimType

      // Profil
      document.getElementById('p-profil').classList.remove('empty')
      const LABELS = {
        travel_cancellation: 'Annulation / modification de voyage',
        rental_vehicle:      'Dommage véhicule de location',
        fraud_identity:      'Fraude / hameçonnage bancaire',
        repatriation:        'Assistance / rapatriement médical',
        layoff:              'Licenciement économique',
        illness:             'Arrêt maladie',
        business_insolvency: 'Cessation de paiement',
        other_claim:         'Sinistre',
      }
      const typeLabel = LABELS[type] || type || 'En cours d\'identification'

      let profilHtml = ''
      if (type && type !== 'coverage_question') {
        profilHtml += `<div style="margin-bottom:8px"><span class="badge risk-${currentIncident?.amount ? 'med' : 'low'}">${escHtml(typeLabel)}</span></div>`
      }
      if (userAdhesion) {
        profilHtml += `<div class="kv"><span class="k">Déclarant</span><span class="v">${escHtml(`${userAdhesion.firstname || ''} ${userAdhesion.lastname || ''}`.trim())}</span></div>`
        profilHtml += `<div class="kv"><span class="k">Contrat</span><span class="v">${escHtml(userAdhesion.productName || 'Owen')}</span></div>`
      }
      if (inc.date)     profilHtml += `<div class="kv"><span class="k">Date incident</span><span class="v">${escHtml(inc.date)}</span></div>`
      if (inc.location) profilHtml += `<div class="kv"><span class="k">Lieu</span><span class="v">${escHtml(inc.location)}</span></div>`
      if (inc.amount)   profilHtml += `<div class="kv"><span class="k">Montant</span><span class="v">${escHtml(inc.amount)} €</span></div>`
      if (inc.description) profilHtml += `<div class="kv"><span class="k">Description</span><span class="v" style="font-size:12px">${escHtml(inc.description)}</span></div>`
      document.getElementById('profil-body').innerHTML = profilHtml || '<span class="note">Collecte en cours…</span>'

      // Tracker (avance selon les données collectées)
      document.getElementById('p-track').classList.remove('empty')
      const steps = ['Demande reçue', 'Identité vérifiée', 'Garantie vérifiée', 'Pièces à fournir', 'Contrôles', 'Décision', 'Indemnisation']
      let h = ''
      steps.forEach((t, i) => { h += `<div class="tstep" data-i="${i}"><div class="ic"></div><div class="lb">${t}</div></div>` })
      document.getElementById('track-body').innerHTML = h

      // Avancer le tracker selon les infos collectées
      let step = 0
      if (currentClaimType) step = 1
      if (inc.date || inc.location) step = 2
      trackTo(step)
    }

    // ── Helpers proofOfClaims ─────────────────────────────────────────────
    const CLAIM_TYPE_MAX_AMOUNTS = {
      travel_cancellation: '5 000 €',
      rental_vehicle:      '30 000 € (vol) · franchise couverte',
      fraud_identity:      '3 000 €',
      repatriation:        'Décision équipe médicale',
      layoff:              'Selon contrat',
      illness:             'Selon contrat',
      business_insolvency: 'Selon contrat',
      other_claim:         'Selon contrat',
    }

    function getProofOfClaimsForCurrentType() {
      // 1. Match exact sur le nom de garantie renvoyé par l'IA (fiable — pas d'ambiguïté entre natures)
      let nature = currentClaimNature
        ? availableNatures.find(n => (n.name || n.label || '').trim().toLowerCase() === currentClaimNature.trim().toLowerCase())
        : null

      // 2. Filet de sécurité si l'IA n'a pas renseigné claim_nature (ancien prompt Notion, réponse mal formée…)
      if (!nature) {
        const keywords = CLAIM_TYPE_KEYWORDS[currentClaimType] || []
        nature = keywords.length
          ? availableNatures.find(n => {
              const label = (n.name || n.label || '').toLowerCase()
              return keywords.some(k => label.includes(k))
            })
          : availableNatures[0]
      }
      return (nature?.proofOfClaims || []).filter(p => p && p._id)
    }

    function matchFileToPoc(filename, pocs, usedIds) {
      const norm = filename.toLowerCase().replace(/[_\-\.]/g, ' ')
      for (const poc of pocs) {
        if (usedIds.has(String(poc._id))) continue
        const words = (poc.name || '').toLowerCase().split(/\s+/).filter(w => w.length > 3)
        if (words.some(w => norm.includes(w))) return poc
      }
      return pocs.find(p => !usedIds.has(String(p._id))) || null
    }

    // ── Suivi d'un dossier sinistre déjà déclaré ──────────────────────────
    const FOLLOWUP_KEYWORDS = [
      'où en est', 'ou en est', 'suivi de mon dossier', 'suivi de dossier', 'suivi du dossier',
      'statut de mon dossier', 'état de mon dossier', 'etat de mon dossier', 'mon dossier sinistre',
      'sinistre en cours', 'avancement de mon dossier', 'avancement du dossier',
    ]
    const TRANSCRIPT_KEYWORDS = [
      'transcription', 'transcript', 'copie de la conversation', 'copie de notre conversation',
      'récupérer la conversation', 'recuperer la conversation', 'export de la conversation',
    ]

    function isFollowUpRequest(v) {
      const lc = (v || '').toLowerCase()
      return FOLLOWUP_KEYWORDS.some(k => lc.includes(k))
    }

    function isTranscriptRequest(v) {
      const lc = (v || '').toLowerCase()
      return TRANSCRIPT_KEYWORDS.some(k => lc.includes(k))
    }

    async function fetchClientClaims() {
      try {
        const claims = await fetchWithAuth('/claims')
        return Array.isArray(claims) ? claims : []
      } catch (e) {
        return []
      }
    }

    // Justificatifs requis (claim.nature.proofOfClaims) sans document accepté/en cours en face
    function getMissingProofs(claim) {
      const required = claim?.nature?.proofOfClaims || []
      const provided = claim?.documents || []
      return required.filter(proof => {
        const doc = provided.find(d => String(d.proofOfClaimsId) === String(proof._id))
        return !doc || doc.status === 'refusé'
      })
    }

    async function startFollowUp(userMsg) {
      bubble('user', escHtml(userMsg))
      convo.push({ role: 'user', content: userMsg })
      const t = document.createElement('div')
      t.className = 'typing'; t.innerHTML = '<span></span><span></span><span></span>'
      logEl.appendChild(t); scrollLog()

      const claims = await fetchClientClaims()
      t.remove()

      const openClaims = claims.filter(c => c?.status && !c.status.startsWith('Closed'))

      if (!openClaims.length) {
        bubble('bot', 'Je ne trouve pas de dossier sinistre en cours sur votre compte. Souhaitez-vous en déclarer un nouveau ?')
        clearChips()
        return
      }

      // Le plus récent en premier (déjà trié côté backend par date de création)
      const claim = openClaims[0]
      const natureLabel = claim.nature?.name || 'sinistre'
      bubble('bot', `J'ai retrouvé votre dossier <strong>${escHtml(claim.shortId || String(claim._id).slice(-8))}</strong> — ${escHtml(natureLabel)}. C'est bien celui-ci ?`)

      const missing = getMissingProofs(claim)
      if (missing.length > 0) {
        bubble('bot', `Votre dossier est toujours ouvert, il manque encore ${missing.length} justificatif${missing.length > 1 ? 's' : ''} pour son instruction : ${missing.map(p => escHtml(p.name)).join(', ')}.`)
        renderFollowUpDocChips(claim, missing)
      } else {
        bubble('bot', 'Tous vos justificatifs ont bien été reçus, votre dossier est en cours d\'analyse par notre équipe sinistres.')
        clearChips()
      }
    }

    function renderFollowUpDocChips(claim, missing) {
      let remaining = [...missing]
      const rejectedIds = new Set() // proofOfClaimsId dont le dernier essai a été rejeté par l'IA
      const uploadedHashes = new Map() // proofOfClaimsId -> empreinte du fichier déjà transmis pour ce dossier
      const MAX_SIZE = 4.5 * 1024 * 1024
      let chipsEl = null // ancré une fois dans le fil du chat — reste en place, ne remonte pas au fil des questions suivantes

      function makeFileInput() {
        const inp = document.createElement('input')
        inp.type = 'file'; inp.accept = '.pdf,.jpg,.jpeg,.png,.doc,.docx'
        inp.style.display = 'none'
        document.body.appendChild(inp)
        return inp
      }

      function afterUploadSuccess() {
        if (remaining.length > 0) {
          bubble('bot', `Merci ! Il reste encore ${remaining.length} justificatif${remaining.length > 1 ? 's' : ''} à téléverser ultérieurement : ${remaining.map(p => escHtml(p.name)).join(', ')}.`)
          render()
        } else {
          bubble('bot', 'Parfait, tous les justificatifs manquants ont été transmis. Votre dossier va être instruit par notre équipe sinistres.')
          if (chipsEl) { chipsEl.remove(); chipsEl = null }
        }
      }

      function render() {
        if (!chipsEl) {
          chipsEl = document.createElement('div')
          chipsEl.className = 'msg-inline-action'
          logEl.appendChild(chipsEl)
        }
        chipsEl.innerHTML = ''
        remaining.forEach(proof => {
          const rejected = rejectedIds.has(String(proof._id))
          const btn = document.createElement('button')
          btn.className = rejected ? 'chip adu-chip-rejected' : 'chip'
          btn.innerHTML = rejected ? `✕ ${escHtml(proof.name)}` : `📎 ${escHtml(proof.name)}`
          const inp = makeFileInput()
          btn.onclick = () => { inp.value = ''; inp.click() }
          inp.onchange = async e => {
            const file = e.target.files[0]
            if (!file) return
            if (file.size > MAX_SIZE) { bubble('bot', `⚠️ ${escHtml(file.name)} dépasse 4,5 Mo.`); return }
            document.body.removeChild(inp)
            btn.disabled = true
            bubble('user', `📎 ${escHtml(file.name)}`)

            // Détection déterministe (par empreinte du fichier) d'un même document déjà utilisé
            // pour un autre justificatif de ce dossier — l'IA vision juge chaque fichier isolément.
            const hash = await hashFile(file)
            const duplicateEntry = [...uploadedHashes.entries()].find(([pid, h]) => pid !== String(proof._id) && h === hash)
            if (duplicateEntry) {
              const duplicateProof = missing.find(p => String(p._id) === duplicateEntry[0])
              rejectedIds.add(String(proof._id))
              btn.disabled = false
              bubble('bot alert', `⚠️ Ce fichier est identique à celui déjà envoyé pour "${escHtml(duplicateProof?.name || 'un autre justificatif')}". Merci d'envoyer un document différent pour "${escHtml(proof.name)}".`)

              const overrideWrap = document.createElement('div')
              overrideWrap.className = 'msg-inline-action'
              overrideWrap.innerHTML = '<button class="inline-cta">C\'est bien le bon document → transmettre à un agent</button>'
              overrideWrap.querySelector('button').onclick = async () => {
                overrideWrap.remove()
                bubble('user', 'Je confirme, c\'est le bon document.')
                const ok = await uploadFollowUpDoc(claim, proof, file, { skipMismatchBubble: true })
                if (!ok) { render(); return }
                uploadedHashes.set(String(proof._id), hash)
                rejectedIds.delete(String(proof._id))
                remaining = remaining.filter(p => String(p._id) !== String(proof._id))
                afterUploadSuccess()
              }
              logEl.appendChild(overrideWrap)
              scrollLog()

              render()
              return
            }

            // Vérification IA immédiate — bloque l'envoi en cas de doute manifeste
            const t = document.createElement('div')
            t.className = 'typing'; t.innerHTML = '<span></span><span></span><span></span>'
            logEl.appendChild(t); scrollLog()
            let verdict = null
            try {
              const fd = new FormData()
              fd.append('file', file)
              fd.append('proofOfClaimsId', String(proof._id))
              const token = localStorage.getItem('accessToken')
              const res = await fetch(`${apiUrl}/claims/documents/validate-preview`, {
                method: 'POST',
                headers: {
                  Authorization: `Bearer ${token}`,
                  ...(xApiKey ? { 'x-api-key': xApiKey } : {}),
                },
                body: fd,
              })
              const json = await res.json()
              verdict = json?.response || null
            } catch (err) {
              verdict = null // panne réseau/IA → on n'empêche jamais l'envoi, on accepte
            }
            t.remove()
            btn.disabled = false

            if (verdict?.checked && verdict.matches === false) {
              rejectedIds.add(String(proof._id))
              bubble('bot alert', `⚠️ "${escHtml(file.name)}" ne ressemble pas à un(e) ${escHtml(proof.name.toLowerCase())}${verdict.reason ? ` (${escHtml(verdict.reason)})` : ''}. Merci de vérifier le fichier et d'en téléverser un autre.`)

              const overrideWrap = document.createElement('div')
              overrideWrap.className = 'msg-inline-action'
              overrideWrap.innerHTML = '<button class="inline-cta">C\'est le bon document → transmettre à un agent</button>'
              overrideWrap.querySelector('button').onclick = async () => {
                overrideWrap.remove()
                bubble('user', 'Je confirme, c\'est le bon document.')
                const ok = await uploadFollowUpDoc(claim, proof, file, { skipMismatchBubble: true })
                if (!ok) { render(); return }
                uploadedHashes.set(String(proof._id), hash)
                rejectedIds.delete(String(proof._id))
                remaining = remaining.filter(p => String(p._id) !== String(proof._id))
                afterUploadSuccess()
              }
              logEl.appendChild(overrideWrap)
              scrollLog()

              render() // chip repasse en rouge, cliquable pour réessayer avec un autre fichier
              return
            }

            const ok = await uploadFollowUpDoc(claim, proof, file)
            if (!ok) { render(); return }
            uploadedHashes.set(String(proof._id), hash)
            rejectedIds.delete(String(proof._id))
            remaining = remaining.filter(p => String(p._id) !== String(proof._id))
            afterUploadSuccess()
          }
          chipsEl.appendChild(btn)
        })
        scrollLog()
      }
      render()
    }

    // Retourne true si l'upload a réussi, false si l'envoi a échoué. Le doute sur le contenu est
    // déjà traité en amont (bloqué puis confirmé ou re-téléversé) — skipMismatchBubble évite de
    // resignaler ici un justificatif déjà acquitté dans le chat.
    async function uploadFollowUpDoc(claim, proof, file, opts = {}) {
      try {
        const formData = new FormData()
        formData.append('adhesionId', claim.adhesionId || userAdhesion?._id || '')
        formData.append('files', file, JSON.stringify({ name: file.name, proofOfClaimsId: proof._id }))
        const token = localStorage.getItem('accessToken')
        const res = await fetch(`${apiUrl}/claims/${claim._id}/documents`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            ...(xApiKey ? { 'x-api-key': xApiKey } : {}),
          },
          body: formData,
        })
        const json = await res.json().catch(() => ({}))
        if (!res.ok) throw new Error(json?.response || `HTTP ${res.status}`)

        if (!opts.skipMismatchBubble) {
          const validation = (json?.response?.documentsValidation || [])
            .find(v => String(v.proofOfClaimsId) === String(proof._id))
          if (validation?.checked && validation.matches === false) {
            bubble('bot alert', `⚠️ "${escHtml(file.name)}" ne ressemble pas à un(e) ${escHtml(proof.name.toLowerCase())}${validation.reason ? ` (${escHtml(validation.reason)})` : ''}. Le fichier a bien été enregistré, mais vérifie que c'est le bon document — tu peux le remplacer en cliquant à nouveau sur le justificatif.`)
          }
        }
        return true
      } catch (err) {
        bubble('bot', `⚠️ Erreur lors de l'envoi de "${escHtml(proof.name)}" (${escHtml(err.message)}). Vous pouvez réessayer.`)
        return false
      }
    }

    // ── Transcript de la conversation, à la demande du client ────────────
    function downloadTranscript() {
      const lines = Array.from(logEl.querySelectorAll('.msg')).map(el => {
        const role = el.classList.contains('user') ? 'Vous' : 'Owen'
        return `${role} : ${el.textContent}`
      })
      const blob = new Blob([lines.join('\n\n')], { type: 'text/plain;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `conversation-owen-${new Date().toISOString().slice(0, 10)}.txt`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    }

    // ── Upload + déclaration entièrement en mode IA (sans flow scripté) ──
    function aiDocsAndDeclare() {
      if (aiDocsStarted) return
      aiDocsStarted = true
      clearChips()
      aiDocFiles = []
      acknowledgedMismatchIds = new Set()
      rejectedPocIds = new Set()
      const pocs = getProofOfClaimsForCurrentType()

      // Tracker → Pièces à fournir
      trackTo(3)

      // Peupler le panel docs droit
      const docsPanel = document.getElementById('p-docs')
      const docsBody  = document.getElementById('docs-body')
      docsPanel.classList.remove('empty')
      docsBody.innerHTML = ''
      pocs.forEach(poc => {
        const row = document.createElement('div')
        row.className = 'row'; row.id = `poc-row-${poc._id}`
        row.innerHTML = `<div class="chk" style="background:var(--n4);display:flex;align-items:center;justify-content:center;font-size:10px;color:#fff">?</div><div><strong style="font-weight:500">${escHtml(poc.name)}</strong></div><span class="st">en attente</span>`
        docsBody.appendChild(row)
      })
      if (!pocs.length) docsBody.innerHTML = '<span class="note">Pièces à définir avec l\'agent.</span>'
      scrollDossier()

      const MAX_SIZE = 4.5 * 1024 * 1024
      let chipsEl = null // ancré une fois dans le fil du chat — reste en place, ne remonte pas au fil des questions suivantes

      function makeFileInput(multiple) {
        const inp = document.createElement('input')
        inp.type = 'file'; inp.accept = '.pdf,.jpg,.jpeg,.png,.doc,.docx'
        inp.multiple = !!multiple; inp.style.display = 'none'
        document.body.appendChild(inp)
        return inp
      }

      function renderDocChips() {
        if (!chipsEl) {
          chipsEl = document.createElement('div')
          chipsEl.className = 'msg-inline-action'
          logEl.appendChild(chipsEl)
        }
        chipsEl.innerHTML = ''

        if (pocs.length > 0) {
          // Un bouton par proof of claim
          pocs.forEach(poc => {
            const already = aiDocFiles.find(d => d.pocId === String(poc._id))
            const rejected = !already && rejectedPocIds.has(String(poc._id))
            const btn = document.createElement('button')
            btn.className = already
              ? (already.forceAcceptedReason ? 'chip adu-chip-forced' : 'chip adu-chip-done')
              : (rejected ? 'chip adu-chip-rejected' : 'chip')
            btn.innerHTML = already
              ? (already.forceAcceptedReason ? `⚠️ ${escHtml(poc.name)}` : `✓ ${escHtml(poc.name)}`)
              : (rejected ? `✕ ${escHtml(poc.name)}` : `📎 ${escHtml(poc.name)}`)

            if (!already) {
              const inp = makeFileInput(false)
              btn.onclick = () => { inp.value = ''; inp.click() }
              inp.onchange = async e => {
                const file = e.target.files[0]
                if (!file) return
                if (file.size > MAX_SIZE) { bubble('bot', `⚠️ ${escHtml(file.name)} dépasse 4,5 Mo.`); return }
                document.body.removeChild(inp)
                bubble('user', `📎 ${escHtml(file.name)}`)

                const acceptFile = (hash) => {
                  rejectedPocIds.delete(String(poc._id))
                  aiDocFiles.push({ file, pocId: String(poc._id), hash })
                  const panelRow = document.getElementById(`poc-row-${poc._id}`)
                  if (panelRow) panelRow.innerHTML = `<div class="chk ok">${CHK}</div><div><strong style="font-weight:500">${escHtml(poc.name)}</strong><span class="ocr">OCR · ${(file.size/1024).toFixed(0)} Ko · analyse OK</span></div><span class="st ok">lu</span>`
                  scrollDossier()
                  renderDocChips()
                }

                btn.disabled = true

                // Détection déterministe (par empreinte du fichier) d'un même document déjà utilisé
                // pour un autre justificatif — l'IA vision ne peut pas le voir, elle juge chaque fichier isolément.
                const hash = await hashFile(file)
                const duplicate = aiDocFiles.find(d => d.pocId !== String(poc._id) && d.hash === hash)
                if (duplicate) {
                  const duplicatePoc = pocs.find(p => String(p._id) === duplicate.pocId)
                  rejectedPocIds.add(String(poc._id))
                  btn.disabled = false
                  bubble('bot alert', `⚠️ Ce fichier est identique à celui déjà envoyé pour "${escHtml(duplicatePoc?.name || 'un autre justificatif')}". Merci d'envoyer un document différent pour "${escHtml(poc.name)}".`)

                  const overrideWrap = document.createElement('div')
                  overrideWrap.className = 'msg-inline-action'
                  overrideWrap.innerHTML = '<button class="inline-cta">C\'est bien le bon document → transmettre à un agent</button>'
                  overrideWrap.querySelector('button').onclick = () => {
                    overrideWrap.remove()
                    acknowledgedMismatchIds.add(String(poc._id))
                    rejectedPocIds.delete(String(poc._id))
                    bubble('user', 'Je confirme, c\'est le bon document.')
                    aiDocFiles.push({ file, pocId: String(poc._id), hash, forceAcceptedReason: 'fichier identique à un autre justificatif déjà transmis' })
                    const panelRow = document.getElementById(`poc-row-${poc._id}`)
                    if (panelRow) panelRow.innerHTML = `<div class="chk" style="background:var(--warn);display:flex;align-items:center;justify-content:center;font-size:11px;color:#fff">!</div><div><strong style="font-weight:500">${escHtml(poc.name)}</strong><span class="ocr">Signalé à l'agent sinistre</span></div><span class="st">à vérifier</span>`
                    scrollDossier()
                    renderDocChips()
                  }
                  logEl.appendChild(overrideWrap)
                  scrollLog()

                  renderDocChips()
                  return
                }

                // Vérification IA immédiate — bloque le justificatif en cas de doute manifeste
                const t = document.createElement('div')
                t.className = 'typing'; t.innerHTML = '<span></span><span></span><span></span>'
                logEl.appendChild(t); scrollLog()

                let verdict = null
                try {
                  const fd = new FormData()
                  fd.append('file', file)
                  fd.append('proofOfClaimsId', String(poc._id))
                  const token = localStorage.getItem('accessToken')
                  const res = await fetch(`${apiUrl}/claims/documents/validate-preview`, {
                    method: 'POST',
                    headers: {
                      Authorization: `Bearer ${token}`,
                      ...(xApiKey ? { 'x-api-key': xApiKey } : {}),
                    },
                    body: fd,
                  })
                  const json = await res.json()
                  verdict = json?.response || null
                } catch (err) {
                  verdict = null // panne réseau/IA → on n'empêche jamais la déclaration, on accepte
                }
                t.remove()
                btn.disabled = false

                if (verdict?.checked && verdict.matches === false) {
                  rejectedPocIds.add(String(poc._id))
                  bubble('bot alert', `⚠️ "${escHtml(file.name)}" ne ressemble pas à un(e) ${escHtml(poc.name.toLowerCase())}${verdict.reason ? ` (${escHtml(verdict.reason)})` : ''}. Merci de vérifier le fichier et d'en téléverser un autre.`)
                  const rejectedRow = document.getElementById(`poc-row-${poc._id}`)
                  if (rejectedRow) rejectedRow.innerHTML = `<div class="chk" style="background:#d64545;display:flex;align-items:center;justify-content:center;font-size:11px;color:#fff">✕</div><div><strong style="font-weight:500">${escHtml(poc.name)}</strong><span class="ocr">Ne correspond pas — à renvoyer</span></div><span class="st">rejeté</span>`

                  const overrideWrap = document.createElement('div')
                  overrideWrap.className = 'msg-inline-action'
                  overrideWrap.innerHTML = '<button class="inline-cta">C\'est le bon document → transmettre à un agent</button>'
                  overrideWrap.querySelector('button').onclick = () => {
                    overrideWrap.remove()
                    acknowledgedMismatchIds.add(String(poc._id))
                    rejectedPocIds.delete(String(poc._id))
                    bubble('user', 'Je confirme, c\'est le bon document.')
                    aiDocFiles.push({ file, pocId: String(poc._id), hash, forceAcceptedReason: verdict.reason || 'vérification IA non concluante' })
                    const panelRow = document.getElementById(`poc-row-${poc._id}`)
                    if (panelRow) panelRow.innerHTML = `<div class="chk" style="background:var(--warn);display:flex;align-items:center;justify-content:center;font-size:11px;color:#fff">!</div><div><strong style="font-weight:500">${escHtml(poc.name)}</strong><span class="ocr">Signalé à l'agent sinistre</span></div><span class="st">à vérifier</span>`
                    scrollDossier()
                    renderDocChips()
                  }
                  logEl.appendChild(overrideWrap)
                  scrollLog()

                  // Le chip reste disponible pour réessayer avec un autre fichier
                  renderDocChips()
                  return
                }

                acceptFile(hash)
              }
            }
            chipsEl.appendChild(btn)
          })
        } else {
          // Pas de pocs définis → bouton upload générique multi-fichiers
          const already = aiDocFiles.length > 0
          const btn = document.createElement('button')
          btn.className = already ? 'chip adu-chip-done' : 'chip'
          btn.innerHTML = already ? `✓ ${aiDocFiles.length} fichier${aiDocFiles.length > 1 ? 's' : ''} joint${aiDocFiles.length > 1 ? 's' : ''}` : '📎 Téléverser mes justificatifs'

          if (!already) {
            const inp = makeFileInput(true)
            btn.onclick = () => { inp.value = ''; inp.click() }
            inp.onchange = e => {
              const files = Array.from(e.target.files || [])
              if (!files.length) return
              const oversized = files.filter(f => f.size > MAX_SIZE)
              if (oversized.length) { bubble('bot', `⚠️ ${oversized.map(f => escHtml(f.name)).join(', ')} dépasse 4,5 Mo.`); return }
              files.forEach(file => aiDocFiles.push({ file, pocId: null }))
              document.body.removeChild(inp)
              bubble('user', `📎 ${files.length} fichier${files.length > 1 ? 's' : ''} joint${files.length > 1 ? 's' : ''}`)
              scrollDossier()
              renderDocChips()
            }
            chipsEl.appendChild(btn)
          } else {
            chipsEl.appendChild(btn)
          }
        }

        // Bouton Continuer toujours présent
        const cont = document.createElement('button')
        cont.className = 'chip cta'
        cont.textContent = 'Continuer →'
        cont.onclick = () => { cont.disabled = true; showAiDeclarationButton() }
        chipsEl.appendChild(cont)
        scrollLog()
      }

      botSayFast(['Joignez vos justificatifs pour compléter votre dossier.'], renderDocChips)
    }

    function showAiDeclarationButton() {
      clearChips()

      // Tracker → Contrôles
      trackTo(4)

      // Panel contrôles IA simplifié
      const ctrlPanel = document.getElementById('p-ctrl')
      const ctrlBody  = document.getElementById('ctrl-body')
      ctrlPanel.classList.remove('empty')
      ctrlBody.innerHTML = [
        ['Identité & authentification', 'ok'],
        ['Contrat actif', 'ok'],
        ['Garantie applicable', 'ok'],
        ['Délai de déclaration', 'ok'],
        ['Cohérence des informations', 'ok'],
      ].map(([label, st]) =>
        `<div class="row"><div class="chk ok">${CHK}</div><div>${escHtml(label)}</div><span class="st ok">OK</span></div>`
      ).join('')
      scrollDossier()

      // Tracker → Décision
      trackTo(5)

      // Panel décision avec montant déclaré + plafond
      const decPanel = document.getElementById('p-dec')
      const decBody  = document.getElementById('dec-body')
      decPanel.classList.remove('empty')
      const inc       = currentIncident || {}
      const maxAmount = CLAIM_TYPE_MAX_AMOUNTS[currentClaimType] || 'Selon contrat'
      let decH = `<span class="dstat review">En cours d'analyse</span><div class="calc">`
      if (inc.amount) decH += `<div class="line"><span>Montant déclaré</span><span class="v">${escHtml(String(inc.amount))} €</span></div>`
      decH += `<div class="line"><span>Plafond contractuel</span><span class="v">${escHtml(maxAmount)}</span></div>`
      decH += `<div class="total"><span>Décision finale</span><span>Sous 24h — équipe sinistres</span></div></div>`
      decH += `<div class="note">Un agent sinistre analysera votre dossier et vous répondra dans les 24h suivant la déclaration.</div>`
      decBody.innerHTML = decH
      scrollDossier()

      const pocsForDecl = getProofOfClaimsForCurrentType()
      const allDocsUploaded = pocsForDecl.length > 0 && pocsForDecl.every(poc => aiDocFiles.some(d => d.pocId === String(poc._id)))

      const declMessages = [
        'Une fois cette déclaration validée, nous aurons besoin de tous vos justificatifs demandés afin de valider la prise en charge et le montant d\'indemnisation associé.',
      ]
      // Inutile de relancer sur les délais de téléversement si tous les justificatifs requis sont déjà déposés.
      if (pocsForDecl.length > 0 && !allDocsUploaded) {
        declMessages.push('Conseil : ne tardez pas trop à téléverser vos justificatifs, car sans eux, votre dossier ne pourra pas progresser. Veillez à ce que ces justificatifs soient lisibles : les originaux au format PDF sont toujours plus pratiques à analyser et vous feront gagner du temps.')
      }
      declMessages.push('Si vous n\'avez pas tous vos justificatifs, vous pouvez accéder à tout moment au suivi de votre dossier en vous rendant dans la rubrique sinistre de l\'espace Owen, ou bien en me recontactant directement ici. Si vous avez encore des questions, n\'hésitez pas. À très bientôt et à votre service !')

      botSay(declMessages, () => {
        const btnWrap = document.createElement('div')
        btnWrap.className = 'msg-inline-action'
        btnWrap.innerHTML = '<button class="inline-cta">📋 Je déclare mon sinistre</button>'
        btnWrap.querySelector('button').onclick = () => {
          btnWrap.querySelector('button').disabled = true
          submitClaimFromConversation()
        }
        logEl.appendChild(btnWrap)
        scrollLog()
      })
    }

    // Proposé juste après une déclaration réussie — le client choisit d'aller voir son dossier
    // et/ou de conserver une copie de la conversation, plutôt qu'une redirection automatique.
    function appendClaimSubmittedActions(claimId) {
      const wrap = document.createElement('div')
      wrap.className = 'msg-inline-action'
      wrap.innerHTML = `
        <button type="button" class="inline-cta" id="ob-claim-view-btn">📁 Voir mon dossier sinistre</button>
        <button type="button" class="inline-ghost" id="ob-claim-download-btn">📄 Télécharger la conversation</button>
      `
      wrap.querySelector('#ob-claim-view-btn').onclick = () => { navigateRef.current(`/claims/${claimId}`); closeOverlay() }
      wrap.querySelector('#ob-claim-download-btn').onclick = () => { downloadTranscript() }
      logEl.appendChild(wrap)
      scrollLog()
    }

    // ── Soumission sinistre depuis conversation IA libre ──────────────────
    async function submitClaimFromConversation() {
      if (!userAdhesion) {
        bubble('bot', 'Je n\'ai pas pu récupérer votre contrat. <a href="/claims/new" style="color:var(--p5)">Formulaire manuel →</a>')
        return
      }

      // 1. Match exact sur le nom de garantie renvoyé par l'IA (fiable — même logique que
      // getProofOfClaimsForCurrentType, pour éviter que la catégorie enregistrée diverge de
      // celle que l'agent a annoncée au client pendant la conversation).
      let matchedNature = currentClaimNature
        ? availableNatures.find(n => (n.name || n.label || '').trim().toLowerCase() === currentClaimNature.trim().toLowerCase())
        : null

      // 2. Filet de sécurité si l'IA n'a pas renseigné claim_nature (ancien prompt Notion, réponse mal formée…)
      if (!matchedNature) {
        const keywords = CLAIM_TYPE_KEYWORDS[currentClaimType] || []
        matchedNature = keywords.length
          ? availableNatures.find(n => {
              const label = (n.name || n.label || '').toLowerCase()
              return keywords.some(k => label.includes(k))
            })
          : null
      }
      const natureId = matchedNature?._id || availableNatures[0]?._id

      if (!natureId) {
        bubble('bot', 'Aucune nature de sinistre disponible. <a href="/claims/new" style="color:var(--p5)">Formulaire manuel →</a>')
        return
      }

      const inc = currentIncident || {}
      const natureLabel = matchedNature?.name || availableNatures.find(n => n._id === natureId)?.name || 'Non précisée'
      const dateLabel = inc.date ? new Date(inc.date).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 'Non précisée'
      const descriptionLabel = inc.description || 'Sinistre déclaré via l\'assistant IA — voir la conversation complète pour le détail.'

      // Récap structuré par points — la ligne Circonstances porte le résumé de toute la
      // conversation rédigé par l'IA. Jamais le dump brut des messages du client (trop
      // verbeux, pas exploitable par l'agent sinistre). Conversation complète via AssistantLog.
      let circumstance = `[Assistant IA Owen]\nDate : ${dateLabel}\nLieu : ${inc.location || 'Non précisé'}\nGarantie : ${natureLabel}\nCirconstances : ${descriptionLabel}`.slice(0, 1800)

      // Justificatifs confirmés par le client malgré une alerte IA — note pour l'agent sinistre
      const forcedDocs = aiDocFiles.filter(d => d.forceAcceptedReason)
      if (forcedDocs.length) {
        const pocsForNote = getProofOfClaimsForCurrentType()
        const notes = forcedDocs.map(d => {
          const name = pocsForNote.find(p => String(p._id) === d.pocId)?.name || 'un justificatif'
          return `"${name}" confirmé par le client malgré une alerte IA (${d.forceAcceptedReason})`
        }).join(' ; ')
        circumstance += `\n\n[Vérification IA — à contrôler] ${notes}`
      }
      circumstance = circumstance.slice(0, 2000)

      const t = document.createElement('div')
      t.className = 'typing'; t.innerHTML = '<span></span><span></span><span></span>'
      logEl.appendChild(t); scrollLog()
      clearChips()

      try {
        const formData = new FormData()
        formData.append('adhesionId', userAdhesion._id)
        formData.append('notPersonnalClaimDeclaration', 'false')
        formData.append('incidentDate', inc.date ? new Date(inc.date).toISOString() : new Date().toISOString())
        formData.append('location', inc.location || 'France')
        formData.append('nature', natureId)
        formData.append('circumstance', circumstance)

        const fields = ['firstname', 'lastname', 'email', 'phone', 'birthdate',
          'address', 'zipcode', 'city', 'country', 'placeOfBirth',
          'additionalAddress', 'organizationName',
          'headquarterAddress', 'headquarterZipcode', 'headquarterCity', 'headquarterCountry',
          'companyImmatriculation', 'contractCountry']
        fields.forEach(f => {
          if (userAdhesion[f] != null && userAdhesion[f] !== '') formData.append(f, userAdhesion[f])
        })
        formData.append('countryOfBirth', userAdhesion.countryOfBirth || userAdhesion.country || 'france')

        if (aiDocFiles.length > 0) {
          aiDocFiles.forEach(({ file, pocId }) => {
            formData.append('files', file, JSON.stringify({ name: file.name, ...(pocId ? { proofOfClaimsId: pocId } : {}) }))
          })
        } else if (userFiles && userFiles.length > 0) {
          const pocs    = getProofOfClaimsForCurrentType()
          const usedIds = new Set()
          Array.from(userFiles).forEach(file => {
            const poc = matchFileToPoc(file.name, pocs, usedIds)
            if (poc) usedIds.add(String(poc._id))
            formData.append('files', file, JSON.stringify({
              name: file.name,
              ...(poc?._id ? { proofOfClaimsId: poc._id } : {}),
            }))
          })
        }

        const token = localStorage.getItem('accessToken')
        const res = await fetch(`${apiUrl}/claims`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            ...(xApiKey ? { 'x-api-key': xApiKey } : {}),
          },
          body: formData,
        })
        const json = await res.json()
        if (!res.ok) throw new Error(json?.response || `HTTP ${res.status}`)

        t.remove()
        trackTo(6)
        const claimId = json?.response?.id || json?.id
        logAssistantEvent('claim_submitted', { claimId: claimId || undefined })
        bubble('bot', `✅ <strong>Déclaration enregistrée !</strong><br>Référence : <strong>${claimId}</strong><br>Vous allez être redirigé vers votre dossier sinistre.`)

        // Filet de sécurité : la plupart des doutes ont déjà été traités (bloqués puis confirmés
        // ou re-téléversés) au moment de l'upload — on ne resignale pas ceux déjà acquittés dans le chat.
        const mismatches = (json?.response?.documentsValidation || [])
          .filter(v => v.checked && v.matches === false)
          .filter(v => !acknowledgedMismatchIds.has(String(v.proofOfClaimsId)))
        if (mismatches.length) {
          const pocs = getProofOfClaimsForCurrentType()
          const names = mismatches.map(m => pocs.find(p => String(p._id) === String(m.proofOfClaimsId))?.name).filter(Boolean)
          bubble('bot alert', `⚠️ Petite vérification : ${names.length ? escHtml(names.join(', ')) : 'un des documents'} envoyé${names.length > 1 ? 's' : ''} ne ressemble${names.length > 1 ? 'nt' : ''} pas tout à fait au justificatif attendu. Ils ont bien été enregistrés, mais un agent vérifiera — n'hésite pas à en renvoyer un meilleur depuis ton dossier si besoin.`)
        }

        appendClaimSubmittedActions(claimId)
        setTimeout(() => { if (active) { navigateRef.current(`/claims/${claimId}`); closeOverlay() } }, 2200)
      } catch (err) {
        t.remove()
        bubble('bot', `Erreur lors de l'enregistrement (${err.message}). <a href="/claims/new" style="color:var(--p5)">Formulaire manuel →</a>`)
        chips([{ l: '📝 Formulaire manuel', cta: true, nav: true, href: '/claims/new' }])
      }
    }

    // ── Cover checker (mode libre) ────────────────────────────────────────
    function coverAnswer(q) {
      const lc = (q || '').toLowerCase()
      for (let i = 0; i < COVER_KB.length; i++) {
        for (let j = 0; j < COVER_KB[i].k.length; j++) {
          if (lc.indexOf(COVER_KB[i].k[j]) >= 0) return COVER_KB[i]
        }
      }
      return null
    }

    function freeStart() {
      currentSystemPrompt = buildSystemPrompt()
      // Charge le prompt Notion en arrière-plan si REACT_APP_OWEN_ASSISTANT_PROMPT_SOURCE=notion, puis rebâtit le system prompt
      fetchSystemPrompt().then(() => { currentSystemPrompt = buildSystemPrompt() })
      // Charge l'état réel des sinistres en cours en arrière-plan, puis rebâtit le system prompt
      fetchOpenClaimsContext().then(() => { currentSystemPrompt = buildSystemPrompt() })
      startSession()
      clearChips(); clearSuggestions()
      botSayFast([
        `Bonjour 👋 Je suis <strong>Owen</strong>, un agent conversationnel IA qui va vous accompagner dans votre démarche. ${AI_INFO_ICON_HTML}`,
      ], () => {
        wireAiInfoTooltip()
        botSayFast(['Décrivez votre situation et je vous guide vers la bonne garantie.'])
      })
    }

    function freeReply(hit) {
      botSay([hit.a], () => { clearChips() })
    }

    // ── Réponse IA (API Anthropic via backend ou window.claude) ──────────
    function aiReply(userMsg) {
      bubble('user', escHtml(userMsg))
      const t = document.createElement('div')
      t.className = 'typing'
      t.innerHTML = '<span></span><span></span><span></span>'
      logEl.appendChild(t)
      scrollLog()
      const btn = document.querySelector('#composer button')
      ci.disabled = true; if (btn) btn.disabled = true
      convo.push({ role: 'user', content: userMsg })
      const messageIndex = convo.filter(m => m.role === 'user').length

      // Debug transparence : quelle source de prompt est réellement active pour cet appel.
      // eslint-disable-next-line no-console
      console.log(
        `%c[OwenAssistant] source=${PROMPT_SOURCE} | NOTION_CONTENT=${NOTION_CONTENT ? 'chargé (' + NOTION_CONTENT.length + ' car.)' : 'vide → SYSTEM_PROMPT_BASE'}`,
        'color:#0000c9;font-weight:bold'
      )
      // eslint-disable-next-line no-console
      console.log('[OwenAssistant] system prompt envoyé :', currentSystemPrompt)

      function onDone(raw) {
        t.remove(); ci.disabled = false; if (btn) btn.disabled = false
        let parsed = null
        try {
          const s = raw.indexOf('{'), e = raw.lastIndexOf('}')
          if (s >= 0 && e > s) parsed = JSON.parse(raw.slice(s, e + 1).replace(/,\s*([}\]])/g, '$1'))
        } catch (ex) {}
        // Nettoyer le reply : si ça ressemble à du JSON, remplacer par message générique
        if (parsed && parsed.reply && parsed.reply.trim().startsWith('{')) {
          parsed.reply = 'Je n\'ai pas pu formuler une réponse correcte. Pouvez-vous reformuler votre question ?'
        }
        if (parsed && parsed.reply) {
          convo.push({ role: 'assistant', content: raw })
          bubble('bot', parsed.reply)

          // Détecter un type de sinistre → bouton déclaration
          const NOT_CLAIM = ['coverage_question', 'unknown', null, undefined]
          if (parsed.claim_type && !NOT_CLAIM.includes(parsed.claim_type)) {
            currentClaimType = parsed.claim_type
          }
          if (parsed.claim_nature) {
            currentClaimNature = parsed.claim_nature
          }
          if (parsed.propose_rdv === true) {
            appendRdvButton()
          }
          if (parsed.incident) {
            // Ne fusionne que les champs renseignés — un tour qui ne redonne pas la description
            // (souvent null une fois le sujet passé aux justificatifs) ne doit pas effacer le résumé déjà capturé.
            const merged = { ...(currentIncident || {}) }
            for (const [k, v] of Object.entries(parsed.incident)) {
              if (v !== null && v !== undefined && v !== '') merged[k] = v
            }
            currentIncident = merged
          }

          if (currentClaimType || currentIncident) {
            updateDossierFromAI()
          }

          // L'IA a identifié (en langage libre, hors flow mots-clés) un dossier déjà ouvert dont
          // il manque des justificatifs → on propose les mêmes chips d'upload que startFollowUp().
          if (parsed.claim_followup_id && followUpChipsClaimId !== String(parsed.claim_followup_id)) {
            const claim = OPEN_CLAIMS_RAW.find(c => String(c._id) === String(parsed.claim_followup_id))
            if (claim) {
              const missing = getMissingProofs(claim)
              if (missing.length > 0) {
                followUpChipsClaimId = String(claim._id)
                renderFollowUpDocChips(claim, missing)
              }
            }
          }

          if (parsed.complete_claim === true && currentClaimType && !aiDocsStarted) {
            aiDocsStarted = true
            const pocs = getProofOfClaimsForCurrentType()
            if (pocs.length > 0) {
              aiDocsStarted = false
              setTimeout(() => { if (active) aiDocsAndDeclare() }, 800)
            } else {
              setTimeout(() => { if (active) showAiDeclarationButton() }, 800)
            }
          }
        } else {
          convo.push({ role: 'assistant', content: raw })
          // Ne jamais afficher du JSON brut — message générique si le parsing a échoué
          const looksLikeJson = raw && raw.trim().startsWith('{')
          bubble('bot', looksLikeJson ? 'Je n\'ai pas pu analyser votre demande. Pouvez-vous la reformuler ?' : (raw || 'Désolé, je n\'ai pas pu traiter votre demande.'))
          clearChips()
        }
      }

      function onErr(err) {
        t.remove(); ci.disabled = false; if (btn) btn.disabled = false
        // Erreur réseau pure (pas de réponse backend) : on bascule sur le fallback
        // mots-clés local, sans afficher d'erreur — comportement déjà en place.
        if (!err || err.message === 'Failed to fetch') {
          fallbackKeyword(userMsg)
          return
        }
        // Erreur backend catégorisée (voir AI_ERROR_MESSAGES) : jamais de message
        // technique brut affiché au client.
        const friendly = AI_ERROR_MESSAGES[err.category] || AI_ERROR_MESSAGES.unknown
        bubble('bot', `⚠️ ${friendly}`)
        clearChips()
      }

      if (typeof window.claude !== 'undefined' && typeof window.claude.complete === 'function') {
        window.claude.complete({ system: currentSystemPrompt, messages: convo, max_tokens: 600 })
          .then(raw => onDone(typeof raw === 'string' ? raw : JSON.stringify(raw)))
          .catch(onErr)
      } else {
        // Appel via votre proxy backend (voir §8.2 du PRD) — CORS bloqué sans backend → fallback
        fetch(`${apiUrl}/ai/assistant`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            ...(xApiKey ? { 'x-api-key': xApiKey } : {}),
          },
          body: JSON.stringify({ messages: convo, system: currentSystemPrompt, context: userContext, sessionId, messageIndex }),
        })
          .then(async r => {
            const d = await r.json()
            if (!r.ok || d.error) {
              // d.error est une catégorie (timeout, overloaded, rate_limit, server_error,
              // not_configured, unknown...) — jamais le message brut Anthropic/axios,
              // voir app.js /ai/assistant. Le mapping FR se fait dans onErr.
              const error = new Error(d.error || 'unknown')
              error.category = d.error || 'unknown'
              throw error
            }
            return d.reply || ''
          })
          .then(raw => onDone(raw))
          .catch(onErr)
      }
    }

    function fallbackKeyword(v) {
      const hit = coverAnswer(v)
      if (hit) freeReply(hit)
      else { bubble('bot', 'Je peux vous renseigner sur l\'<strong>annulation voyage</strong>, le <strong>véhicule de location</strong>, la <strong>fraude / phishing</strong> ou le <strong>rapatriement médical</strong>. Quel est votre sujet&nbsp;?'); clearChips() }
    }

    // ── Soumission du formulaire ──────────────────────────────────────────
    comp.onsubmit = e => {
      e.preventDefault()
      const v = ci.value.trim()
      if (!v) return
      ci.value = ''
      resizeComposer()
      clearSuggestions()
      if (isTranscriptRequest(v)) {
        bubble('user', escHtml(v))
        downloadTranscript()
        bubble('bot', '📄 Votre transcription a été téléchargée. Vous pouvez la conserver ou nous la transmettre si besoin.')
        return
      }
      if (isFollowUpRequest(v)) { startFollowUp(v); return }
      aiReply(v)
    }

    // Entrée envoie le message, Maj+Entrée insère un retour à la ligne (comportement standard des chats)
    function resizeComposer() {
      ci.style.height = 'auto'
      ci.style.height = `${Math.min(ci.scrollHeight, 120)}px`
    }
    if (ci) {
      ci.oninput = () => { clearSuggestions(); resizeComposer() }
      ci.onkeydown = e => {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault()
          comp.requestSubmit()
        }
      }
    }

    // ── Initialisation : mode cover checker ───────────────────────────────
    freeStart()

    // ── Échap ferme l'overlay ─────────────────────────────────────────────
    const escHandler = e => { if (e.key === 'Escape' && !ovl.hidden) closeOverlay() }
    document.addEventListener('keydown', escHandler)

    // ── Cleanup ───────────────────────────────────────────────────────────
    return () => {
      active = false
      logEl.innerHTML = ''
      quickEl.innerHTML = ''
      document.removeEventListener('keydown', escHandler)
      comp.onsubmit = null
      if (ci) { ci.oninput = null; ci.onkeydown = null }
      fab.onclick = null
      btnClose.onclick = null
      btnToggle.onclick = null
      if (btnDownloadTranscript) btnDownloadTranscript.onclick = null
      if (closeInfoTooltipOnOutsideClick) document.removeEventListener('click', closeInfoTooltipOnOutsideClick)
      document.body.style.overflow = ''
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // ── Markup JSX ───────────────────────────────────────────────────────────
  return (
    <div id="owen-bot" className="size-sm">

      {/* FAB */}
      <button id="ob-fab" aria-label="Ouvrir l'assistant Owen">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd" d="M11.3574 17.0602L10.9056 17.8234C10.503 18.5037 9.49714 18.5037 9.0945 17.8234L8.64275 17.0602C8.29235 16.4682 8.11716 16.1722 7.83574 16.0085C7.55433 15.8449 7.20002 15.8387 6.4914 15.8265C5.44526 15.8085 4.78915 15.7444 4.2389 15.5165C3.21795 15.0936 2.40681 14.2825 1.98392 13.2615C1.66675 12.4958 1.66675 11.5251 1.66675 9.58366V8.75033C1.66675 6.02247 1.66675 4.65854 2.28075 3.65658C2.62431 3.09593 3.09569 2.62456 3.65634 2.28099C4.65829 1.66699 6.02222 1.66699 8.75008 1.66699H11.2501C13.9779 1.66699 15.3419 1.66699 16.3438 2.28099C16.9045 2.62456 17.3758 3.09593 17.7194 3.65658C18.3334 4.65854 18.3334 6.02247 18.3334 8.75033V9.58366C18.3334 11.5251 18.3334 12.4958 18.0162 13.2615C17.5934 14.2825 16.7822 15.0936 15.7613 15.5165C15.211 15.7444 14.5549 15.8085 13.5087 15.8265C12.8001 15.8387 12.4458 15.8449 12.1644 16.0085C11.883 16.1722 11.7078 16.4682 11.3574 17.0602ZM6.66675 9.79199C6.32157 9.79199 6.04175 10.0718 6.04175 10.417C6.04175 10.7622 6.32157 11.042 6.66675 11.042H11.2501C11.5953 11.042 11.8751 10.7622 11.8751 10.417C11.8751 10.0718 11.5953 9.79199 11.2501 9.79199H6.66675ZM6.04175 7.50033C6.04175 7.15515 6.32157 6.87533 6.66675 6.87533H13.3334C13.6786 6.87533 13.9584 7.15515 13.9584 7.50033C13.9584 7.8455 13.6786 8.12533 13.3334 8.12533H6.66675C6.32157 8.12533 6.04175 7.8455 6.04175 7.50033Z" fill="#fff"/>
        </svg>
        <span className="ob-fab-label">Assistant Owen</span>
      </button>

      {/* Overlay */}
      <div id="ob-overlay" hidden>

        {/* Barre de l'overlay */}
        <div className="ob-ovbar">
          <div className="ob-ovtitle">
            <OwenWordmarkWhite />
            <span>Assistant de protection et de sinistre</span>
          </div>
          <div className="ob-ovactions">
            <button id="ob-toggle" className="ob-ovbtn ob-icobtn" title="Agrandir / réduire">
              <span className="ob-tg-grow">⤢</span>
              <span className="ob-tg-shrink">⤡</span>
            </button>
            <button id="ob-ovclose" className="ob-ovbtn ob-icobtn" title="Fermer">×</button>
          </div>
        </div>

        {/* Assistant interne */}
        <div id="ob-asst" className="embed">

          {/* Topbar interne (visible en grand seulement) */}
          <div className="topbar">
            <div className="brand">
              <OwenWordmarkWhite />
            </div>
            <div className="tbtns">
              <a className="tbtn" href="/claims/new">📝 Déclarer le sinistre</a>
            </div>
          </div>

          {/* Stage : chat + dossier */}
          <div className="stage">

            {/* Chat */}
            <section className="chat">
              <div className="chat-head">
                <div className="av">
                  <OwenOLogoWhiteOrange />
                </div>
                <div>
                  <div className="nm">Owen</div>
                  <div className="st"><span className="dot"></span>en ligne · réponses instantanées</div>
                </div>
                <button id="ob-download-transcript" type="button" className="ob-download-btn" title="Télécharger la conversation">📄</button>
              </div>
              <div className="log" id="log"></div>
              <div className="quick" id="quick"></div>
              <div id="composer-suggestions" className="composer-suggestions"></div>
              <form className="composer" id="composer" autoComplete="off">
                <textarea id="composer-input" rows="1" placeholder="Poser une question… (Maj+Entrée pour un retour à la ligne)" autoComplete="off"></textarea>
                <button type="submit">Envoyer</button>
              </form>

              {/* Panneau d'info IA — superposé au-dessus du fil de messages, pas une bulle */}
              <div className="ob-info-tooltip" id="ob-ai-info-tooltip" hidden>
                <button type="button" className="ob-info-close" id="ob-ai-info-close" aria-label="Fermer">✕</button>
                <div className="ob-info-body" id="ob-ai-info-body">
                  <p>Owen est un agent conversationnel développé et entraîné par Owen dans le cadre de sa relation client. Il est en constante évolution et permet d'apporter des réponses pertinentes et complexes dans <strong>95&nbsp;%</strong> des situations rencontrées par nos clients — de l'information au règlement de sinistre.</p>
                  <a href="http://www.get-owen.com/politique-de-confidentialite" target="_blank" rel="noreferrer">Confidentialité des données →</a>
                  <p>Vous avez le droit de refuser d'échanger avec un agent IA et de demander à converser avec un conseiller humain.</p>
                  <button type="button" className="ob-info-human-btn" id="ob-ai-info-human-btn">🧑‍💼 Parler à un conseiller</button>
                </div>
              </div>
            </section>

            {/* Dossier d'audit */}
            <aside className="dossier" id="dossier">
              <div><h2>Dossier en temps réel</h2></div>

              <div className="panel empty" id="p-profil">
                <div className="ttl">👤 Profil &amp; contrat</div>
                <div id="profil-body" className="note">En attente d'identification…</div>
              </div>

              <div className="panel empty" id="p-track">
                <div className="ttl">🧭 Suivi du dossier</div>
                <div className="tracker" id="track-body"></div>
              </div>

              <div className="panel empty" id="p-docs" style={{display:'none'}}>
                <div className="ttl">📎 Pièces &amp; lecture OCR</div>
                <div id="docs-body" className="note">Aucune pièce pour l'instant.</div>
              </div>

              <div className="panel empty" id="p-ctrl">
                <div className="ttl">🛡️ Contrôles automatisés</div>
                <div id="ctrl-body" className="note">Non démarrés.</div>
              </div>

              <div className="panel empty" id="p-dec">
                <div className="ttl">⚖️ Décision &amp; règlement</div>
                <div id="dec-body" className="note">En attente d'analyse.</div>
              </div>
            </aside>
          </div>

        </div>
      </div>
    </div>
  )
}

export default OwenAssistant
